export const API_ENDPOINTS = {
  // =================== USER MANAGEMENT ===================
  // Authentication & Core User Operations
  USERS_LOGIN: "/users/login",
  USERS_REGISTER: "/users/register",
  UNI_LOGIN: "/users/unilogin",
  UNI_LOGINV2: "/users/unilogin_v2",
  UNI_DELETE: "/users/delete-account",
  APPLE_LOGIN: "/users/auth/oauth/apple",
  APPLE_LOGIN2: "/users/auth/oauth/apple2",
  USERS_INTERNAL_LOGIN: "/users/internal_login",
  LINK_GOOGLE_LOGIN: "/users/link_google_login",

  // 2FA Authentication
  TWOFA_SMS_SEND: "/2fa/sms/send",
  TWOFA_SMS_VERIFY: "/2fa/sms/verify",
  TWOFA_EMAIL_SEND: "/2fa/email/send",
  TWOFA_EMAIL_VERIFY: "/2fa/email/verify",
  TWOFA_CONFIRM: "/2fa/confirm",
  TWOFA_TRANSFER_SEND: "/2fa/transfer/send",

  // User Profile & Settings
  FETCH_USER: "/users/userinfo",
  USERS_DETAILS: "/users/details",
  USERS_DASHBOARD: "/users/dashboard",
  USER_SETTINGS: "/users/user-settings",
  USERS_UPDATE_GOOGLE: "/users/add_google_account",
  EMAIL_SETTINGS: "/email-settings",
  USER_CONFIRM: (id) => `/users/${id}/confirm`,
  FETCH_SPEC_USER: (id) => `/users/userinfo/${id}`,

  // User Lists & Admin
  USERS_LIST: "/users",
  USERS_KPI: "/admin/users/kpi",
  USERS_TOP_USERS: "/topusers",
  USER_ADMIN_FETCH: "/admin/users/details_with_credits",
  ADMIN_USER_ADMIN_FETCH: "/admin/users/unified/fetch",

  USER_ADMIN_EDIT: "/admin/users/edit_with_credits",
  SHARED_WITH_ADMIN: "/admin/users/shared-emails",

  // Password Recovery
  USERS_FORGOT: "/users/forgotrequest",
  USERS_FORGOT_ACTION: "/users/forgotaction",

  //AI Admin logic
  ADMIN_CREATOR_UPDATE_AI: (username) =>
    `/admin/creator/${username}/switch_ai_bool`,

  // Global User System
  GLOBAL_USER: "/users/global-user",
  GLOBAL_USER_SEARCH: "/global_user/search",
  GLOBAL_USER_PUBLIC: (id) => `/global_user/${id}/public`,
  GLOBAL_USER_BY_USER_ID: (userId) => `/global_user/by-user-id/${userId}`,
  GLOBAL_USER_BY_CREATOR_USERNAME: (username) => `/global_user/by-creator-username/${username}`,
  GLOBAL_USER_INVITE_CLAIM: "/global_user/invite/claim",
  GLOBAL_USER_CREATOR_INVITE_CLAIM: "/global_user/creator/claim-invite", // NEW: Added creator-specific endpoint
  GLOBAL_USER_GENERATE_INVITE: "/global_user/generate-invite",
  GLOBAL_USER_QUICK_INVITE: (accountType) =>
    `/global_user/quick-invite/${accountType}`,
  GLOBAL_USER_COPY_INVITE: (accountType) =>
    `/global_user/copy-invite/${accountType}`,
  GLOBAL_USER_GENERATE_INVITE_GEN: "/global_user/generate-invite-gen",
  GLOBAL_USER_REFERRALS: "/global_user/referrals",
  GLOBAL_USER_PROFILE: "/global_user/profile",
  GLOBAL_USER_ACTIVITY_SUMMARY: "/global_user/activity-summary",
  ACCOUNT_STATUS: "/global_user/status",
  GLOBAL_USER_REFERRAL_DETAIL_BY_ID: (referralId) =>
    `/global_user/referrals/${referralId}/detail`,

  // NEW: Referral Access Management
  GLOBAL_USER_REFERRAL_ACCESS_GRANT_V2: "/global_user/referrals/access",
  GLOBAL_USER_REFERRAL_ACCESS_REVOKE_V2: "/global_user/referrals/access",
  GLOBAL_USER_REFERRAL_ACCESS_LIST: "/global_user/referrals/access/list",

  // Keep old endpoints for backwards compatibility (deprecated)
  GLOBAL_USER_REFERRAL_ACCESS_GRANT: (referralId) =>
    `/global_user/referrals/${referralId}/access`,
  GLOBAL_USER_REFERRAL_ACCESS_REVOKE: (referralId) =>
    `/global_user/referrals/${referralId}/access`,
  GLOBAL_USER_REFERRAL_MY_ACCESS: "/global_user/referrals/my-access",

  ACCOUNT_LINK_CREATOR: "/global_user/link-creator",
  ACCOUNT_CREATE_CREATOR: "/global_user/create-creator",
  ACCOUNT_CREATE_USER: "/global_user/create-user",
  ACCOUNT_SWITCH_CONTEXT: (contextType) =>
    `/global_user/switch-context/${contextType}`,
  ACCOUNT_CHECK_USERNAME: (username) =>
    `/global_user/check-username/${username}`,
  ACCOUNT_COMPANIES: "/global_user/companies",

  // =================== TEAM MANAGEMENT ===================
  TEAMS: "/users/teams",
  TEAM_DETAILS: (id) => `/users/teams/${id}`,
  TEAM_ASSIGN_USER: (id) => `/users/teams/${id}/assign-user`,
  TEAM_REMOVE_USER: (id) => `/users/teams/${id}/remove-user`,
  USER_TEAMS: (userId) => `/users/teams/user/${userId}`,
  USERS_MYTEAM: "/users/myteam",
  MY_TEAM: "/users/myteam",
  USER_DEACTIVATE: (id) => `/users/${id}/deactivate`,

  // Team Spending Power Management
  TEAM_ALLOCATE_SPENDING: (id) => `/users/teams/${id}/allocate-credit`,
  TEAM_USE_SPENDING: (id) => `/users/teams/${id}/use-credit`,
  TEAM_RELEASE_SPENDING: (id) => `/users/teams/${id}/release-credit`,
  TEAMS_SPENDING_SUMMARY: "/users/teams/credit-summary",
  TEAMS_REBALANCE_SPENDING: "/users/teams/rebalance-credit",
  MY_SPENDING_INFO: "/users/teams/my-credit-info",
  CHECK_SPENDING_LIMIT: "/users/teams/check-spending-limit",
  RECORD_SPENDING: "/users/teams/record-spending",

  // =================== NOTIFICATIONS ===================
  // User Notifications
  NOTIFICATIONS: "/users/notifications",
  NOTIFICATIONS_UNREAD_COUNT: "/users/notifications/unread_count",
  POST_ALL_NOTIFICATIONS: "/users/notifications/all",
  DEVICE_TOKENS: "/users/device_tokens",

  // Creator Notifications
  CREATOR_NOTIFICATIONS: "/creatorUsers/notifications",
  CREATOR_NOTIFICATIONS_UNREAD_COUNT:
    "/creatorUsers/notifications/unread_count",
  CREATOR_NOTIFICATIONS_UNREAD_COLLAB_COUNT:
    "/creatorUsers/notifications/unread_collab_count",
  CREATOR_POST_ALL_NOTIFICATIONS: "/creatorUsers/notifications/all",

  // =================== NOTIFICATIONS (V2 - GLOBAL USER SYSTEM) ===================
  // Core Notification Operations
  NOTIFICATIONS_V2: "/global_user/notifications",
  NOTIFICATIONS_V2_MINIMAL: "/global_user/notifications/minimal",
  NOTIFICATIONS_V2_COUNTS: "/global_user/notifications/counts",
  NOTIFICATIONS_V2_UNREAD_COUNT: "/global_user/notifications/unread_count",
  NOTIFICATION_V2_READ: (id) => `/global_user/notifications/${id}/read`,
  NOTIFICATIONS_V2_MARK_ALL_READ: "/global_user/notifications/mark_all_read",
  NOTIFICATIONS_V2_MARK_SOURCE_READ: (source) =>
    `/global_user/notifications/mark_source_read/${source}`,
  NOTIFICATION_V2_DISMISS: (id) => `/global_user/notifications/${id}/dismiss`,
  NOTIFICATION_V2_DELETE: (id) => `/global_user/notifications/${id}`,
  NOTIFICATIONS_V2_CLEAR_ALL: "/global_user/notifications/clear_all",
  NOTIFICATIONS_V2_CREATE: "/global_user/notifications/create",

  // =================== CAMPAIGN MANAGEMENT ===================
  // Core Campaign Operations
  CAMPAIGNS: "/campaigns",
  CAMPAIGNS_GET: (id) => `/campaigns/${id}`,
  CAMPAIGNS_DETAILS: (id) => `/campaigns/${id}/details`,
  CAMPAIGNS_REPORT_GET: (id) => `/campaigns/${id}/report`,
  CAMPAIGNS_COPY: "/campaigns/copyCampaign",
  CATALOG_COPY: "/campaigns/copyCatalog",
  CAMPAIGNS_SIMILAR: "/campaigns/createSimilar",
  CAMPAIGNS_CLIENT_COMPANY: (id) => `/campaigns/${id}/client-company`,
  CAMPAIGNS_TRACKER:      (id) => `/campaigns/${id}/tracker`,
  CAMPAIGNS_TRACKER_SYNC: (id) => `/campaigns/${id}/tracker/sync`,
  CAMPAIGNS_SET_MANAGER:  (id) => `/campaigns/${id}/manager`,
  // Campaign Workflow
  LAUNCH_CAMPAIGN: "/campaign_handler/launch_campaign",
  UPDATE_CAMPAIGN: "/campaigns/updateStatus",
  DELETE_CAMPAIGN: "/campaigns/delete",
  BULK_ARCHIVE_CAMPAIGNS: "/campaigns/bulk-archive",
  CHECK_CAMPAIGN_RESTRICTIONS: "/campaigns/check-deletion-restrictions",
  COMPLETE_CAMPAIGN: "/campaigns/completeCampaign",
  COMPLETE_CREATOR: (campaignId) => `/campaigns/completeCreator/${campaignId}`,
  COMPLETE_VIDEO: (campaignId) => `/campaigns/completeVideo/${campaignId}`,

  // Campaign Management
  CAMPAIGNS_SHARE: (id) => `/campaigns/${id}/share`,
  CAMPAIGNS_PRICING_VISIBILITY: (id) =>
    `/campaign_handler/${id}/pricing-visibility`,

  CAMPAIGNS_TIMELINE: (id) => `/campaigns/${id}/timeline`,
  CAMPAIGNS_TIMELINE_BY_CREATOR: (campaignId, creatorId) =>
    `/campaigns/${campaignId}/creator/${creatorId}/timeline`,
  CAMPAIGNS_ADDBONUS: (id) => `/campaigns/${id}/add_bonus`,
  UPDATE_CREATOR_LIST: "/campaigns/updateCreatorList",
  UPDATE_MANAGER: "/campaigns/updateManager",
  CAMPAIGN_UPDATE_CREATOR_STATS: "/campaigns/updateCreatorStats",
  UPDATE_CREATORS_STATS: "/campaigns/updateCreatorStats",

  // Campaign Handler
  CAMPAIGN_HANDLER_SPECS: "/campaign_handler/getCampaignCreatorSpecs",
  UPDATE_CREATOR_CAMPAIGN_SPEC: "/campaign_handler/updateCampaignCreatorSpecs",
  UPDATE_META_DATA: "/campaign_handler/campaign/edit",
  CREATOR_NEGOTIATION: (campaign_id) =>
    `/campaign_handler/campaigns/${campaign_id}/negotiation/response`,
  RESEND_OFFER: (campaign_id) =>
    `/campaign_handler/campaigns/${campaign_id}/resend_offer`,
  CAMPAIGN_SEND_FEEDBACK: (campaignId) =>
    `/campaign_handler/sendFeedback/${campaignId}`,

  // Campaign Analytics & History
  CAMPAIGNS_HISTORY: (campaignId) => `/campaign_handler/history/${campaignId}`,
  CAMPAIGNS_CREATOR_HISTORY: (campaignId, creatorId) =>
    `/campaign_handler/creator_history/${campaignId}/${creatorId}`,

  // Campaign Client Management
  CAMPAIGNS_CLIENT: (campaignId) =>
    `/campaign_handler/campaigns/${campaignId}/client`,
  CAMPAIGNS_CLIENT_FETCH: (campaignId) =>
    `/campaign_handler/campaigns/${campaignId}/client/fetch`,
  CAMPAIGNS_CLIENT_REMOVE: (campaignId) =>
    `/campaign_handler/campaigns/${campaignId}/client/remove`, // NEW: Remove client from campaign
  CAMPAIGNS_OPTOUT: (campaignId) => `/campaigns/${campaignId}/optout`,

  // Admin Campaign Management
  CAMPAIGNS_ADMIN: "/admin/campaigns",
  CAMPAIGNS_ADMIN_KPI: "/admin/campaigns/kpi",
  EDIT_CAMPAIGN_ADMIN: "/admin/campaign/edit",
  DELETE_CAMPAIGN_ADMIN: "/admin/campaign/delete",
  COLLABS_ADMIN: "/admin/collaborations/fetch",

  //creator rankings
  CREATOR_MARKETPLACE_RANKING: (creatorId) =>
    `/creatorUsers/creators/${creatorId}/marketplace-ranking`,
  CREATOR_MARKETPLACE_LEADERBOARD:
    "/creatorUsers/creators/marketplace-leaderboard",

  // =================== CREATOR MANAGEMENT ===================
  // Core Creator Operations
  CREATORS: "/creators",
  CREATORS_PARTNERS: "/creators/partners",
  CREATORS_SPEC: (creatorId) => `/creators/${creatorId}`,
  CREATORS_BATCH: "/creators/batch",
  CREATOR_ADD: "/creators/add",
  CREATOR_SIGNUP: "/creators/signup",
  VENDOR_SIGNUP: "/creators/vendors/signup", // Public vendor registration
  CREATOR_UPDATE: "/creators/update",
  CREATOR_DELETE: "/creators/delete",
  CREATOR_SOFT_DELETE: "/creators/soft_delete",
  CREATOR_SEARCH_FOR_PAYMENT: "/creators/search-for-payment",

  // Creator Data & Analytics
  CREATOR_EMAILS: "/creators/emails",
  CREATORS_KPI: "/creators/kpi",
  CREATORS_MANAGER: (agencyid) => `/creators/manager/${agencyid}`,
  CREATOR_AVERAGE_REVIEW: (creatorId) =>
    `/creators/${creatorId}/average_review`,
  CREATOR_REVIEW: (creatorId) => `/creators/${creatorId}/reviews`,
  CREATOR_ACTIVITY: (creatorId) => `/creators/${creatorId}/activity`,

  // Creator Admin
  CREATOR_ADMIN_FETCH: "/admin/creators",
  CREATOR_USER_ADMIN_FETCH: "/admin/creator_users/details_with_credits",
  CREATOR_CREDITS_ADMIN_EDIT: "/admin/creator_users/edit_with_credits",
  ADMIN_CREATOR_EMAILS: "admin/creatoremails",
  ADMIN_CREATOR_PAYMENT_INFO: (creatorId) =>
    `/admin/creators/${creatorId}/payment-info`,

  // Creator Data Management
  CREATOR_DUPLICATES: "/admin/creators/duplicates",
  CREATOR_NUKE_PREVIEW: (identifier) =>
    `/admin/creators/nuke-preview/${identifier}`,
  CREATOR_NUKE: "/admin/creators/nuke",
  CREATOR_NUKE_HISTORY: "/admin/creators/nuke-history",
  CREATOR_MERGE: "/admin/creators/merge",
  CREATOR_MERGE_PREVIEW: (creatorId) =>
    `/admin/creators/${creatorId}/merge-preview`,
  CREATOR_PAYOUT_READ: "/sheets/creatorPayoutInfo/read",
  CREATOR_DATA_READ: "/sheets/creatorData/read",

  // =================== CREATOR CONNECT ===================
  // Creator Authentication
  CREATORCONNECT_LOGIN: "/creatorUsers/login",
  CREATORCONNECT_INTERNALLOGIN: "/creatorUsers/internal_login",
  CREATORCONNECT_REAUTH: "/creatorUsers/reauth",
  CREATORCONNECT_VERIFY: "/creatorUsers/creator/verify",

  // Creator Profile & Settings
  CREATORCONNECT_DASHBOARD: "/creatorUsers/dashboard",
  CREATORCONNECT_ADD: "/creatorUsers/add",
  CREATORCONNECT_EDIT: "/creatorUsers/edit",
  CREATORCONNECT_ONBOARD: "/creatorUsers/onboard",
  CREATORCONNECT_ONBOARD_SERVICE: "/creatorUsers/onboard_with_service",
  CREATORCONNECT_GET: "/creatorUsers/creator",

  // Creator Financial Management
  CREATORCONNECT_EDIT_STRIPE: "/creatorUsers/stripe",
  CREATORCONNECT_PAYOUTS: "/creatorUsers/payouts",
  CREATORCONNECT_FINANCIALS: "/creatorUsers/financials",
  CREATORCONNECT_CONFIRM_PAYOUT: "/creatorUsers/payouts/confirm",
  CREATOR_WALLETS: "/creatorUsers/wallets",
  CREATOR_WALLET_DETAIL: (walletId) => `/creatorUsers/wallets/${walletId}`,
  CREATOR_WALLET_SET_PRIMARY: (walletId) =>
    `/creatorUsers/wallets/${walletId}/set_primary`,
  CREATOR_MIGRATE_PAYMENTS: "/creatorUsers/migrate_legacy_payments",
  CREATOR_TAX_INFO: "/creatorUsers/tax_info",
  CREATOR_PAYMENT_PREFERENCES: "/creatorUsers/payment-preferences",
  CREATOR_CLAIM_PAYOUT: "/creatorUsers/claim-payout",
  CREATORCONNECT_PAYMENT_TRACKING: "/creatorUsers/payment-tracking",

  // Creator Campaign Management
  creatorConnectCampaigns: "/creatorUsers/campaigns",
  CREATORCONNECT_STATUS_CAMPAIGN: (campaignId) =>
    `/creatorUsers/campaigns/${campaignId}/accept`,
  CREATORCONNECT_UPDATE_FIELDS: (campaignId) =>
    `/creatorUsers/campaigns/${campaignId}/update_fields`,
  CREATORCONNECT_NEGOTIATE_CAMPAIGN: (campaignId) =>
    `/creatorUsers/campaigns/${campaignId}/negotiate`,
  CAMPAIGN_CREATOR_TODO: "/creatorUsers/campaigns/todo",

  // Creator Business Operations
  CREATORCONNECT_GOOGLE: "/creatorUsers/google",
  CREATORCONNECT_GMAIL_UNLINK: "/creatorUsers/gmail/unlink",
  CREATORCONNECT_EMAIL_AUTOMATION_TOGGLE:
    "/creatorUsers/email-automation/toggle",
  CREATORCONNECT_EMAILS: "/creatorUsers/emails",
  CREATORCONNECT_PARTNERSHIPS: "/creatorUsers/partnerships",
  CREATORCONNECT_PARTNERSHIPS_SINGLE: (partnershipid) =>
    `/creatorUsers/partnerships/${partnershipid}`,
  CREATORCONNECT_CONTACTS: "/crm/contacts",
  CREATORCONNECT_USERS_BY_COMPANY: "/creatorUsers/users_by_company",
  CREATORCONNECT_MISC: "/creatorUsers/misc_projects_by_creator",
  CREATORCONNECT_COMMISSIONS: "/creatorUsers/commissions",

  // Creator Invoicing
  CREATORCONNECT_INVOICE: (id) => `/creatorUsers/creator-invoice/${id}`,
  CREATORCONNECT_INVOICE_CREATE: "/creatorUsers/create_invoice",

  // Creator CredX & Marketing
  CREATORCONNECT_CREDX_CREDITS: "/credx/credits",
  CREATORCONNECT_CREDX_PITCH: "/credx/send_pitch_email",
  CREATORCONNECT_CREDX_SUBSTRACT: "/credx/subtract_credits",
  CREATORCONNECT_ZAPFEED: "/creatorUsers/fetchzapfeed",
  CREATOR_STATUS: "/creatorUsers/status",

  CREATOR_PROFILE: "/creatorUsers/profile",
  CREATOR_PLATFORMS: "/creatorUsers/platforms",
  CREATOR_PARTNER_UPGRADE: "/creatorUsers/partner/upgrade",

  CREATORCONNECT_GMAIL_UNLINK: "/creatorUsers/gmail/unlink",
  CREATOR_PARTNER_SETTINGS: "/creatorUsers/partner-settings",
  // Creator Admin Email Analysis
  CREATORCONNECT_ADMIN_EMAIL: "/email_analysis",
  CREATORCONNECT_ADMIN_EMAIL_KEYWORDS: "/email_analysis/keywords",
  CREATORCONNECT_ADMIN_EMAIL_GET: (email) => `/email_analysis/${email}`,

  CREATORCONNECT_ONBOARD_PARTNER: "/creatorUsers/onboard_partner",

  // Creator Email Marketing
  CREATOR_AUTHORIZED: "/admin/creator_users/sender_emails",
  CREATOR_AUTHOR_SEND: "/admin/creator_users/send_bulk_email",
  CREATOR_AUTHOR_SEND_FETCH: "/admin/creator_users/email_blasts",

  // =================== PARTNERSHIPS & DELIVERABLES ===================
  // Core Partnership Operations
  PARTNERSHIPS: "/projects/partnerships",
  PARTNERSHIPS_PUBLIC: "/projects/public/partnerships",
  PARTNERSHIPS_CREATE: "/projects/partnerships/create",
  PARTNERSHIPS_FETCH: (id) => `/projects/partnerships/${id}`, // FIXED
  PARTNERSHIPS_CREATE_WITH_DELIVERABLE:
    "/projects/partnerships/create_with_deliverable", // NEW
  PARTNERSHIPS_REFRESH_TOTALS: (id) =>
    `/projects/partnerships/${id}/refresh_totals`, // NEW
  PARTNERSHIPS_SHARE: (id) => `/projects/partnerships/${id}/share`,

  // Partnership Status Management
  UPDATE_PARTNERSHIP_STATUS: (id) => `/projects/partnerships/${id}/status`, // FIXED
  DELETE_PARTNERSHIP: (id) => `/projects/partnerships/${id}`, // FIXED
  PARTNERSHIPS_UPDATE: (id) => `/projects/partnerships/${id}`, // For PUT requests

  ADMIN_PARTNERSHIPS: "/admin/partnerships",

  // Core Deliverable Operations
  DELIVERABLES: "/deliverables",
  CREATE_DELIVERABLES: "/deliverables/create",
  UPDATE_DELIVERABLES: (id) => `/deliverables/update/${id}`, // FIXED
  GET_DELIVERABLE_PARTNERSHIPS: (partnershipId) =>
    `/deliverables/getByPartnership/${partnershipId}`, // FIXED
  CREATE_DELIVERABLES_WITH_PARTNERSHIP: "/deliverables/create_with_partnership", // NEW
  MIGRATE_ORPHANED_DELIVERABLES: "/deliverables/migrate_orphaned", // NEW

  // Partnership-Deliverable Relations
  PARTNERSHIP_DELIVERABLES: (partnershipId, creatorId) =>
    `/deliverables/getByPartnershipAndCreator/${partnershipId}/${creatorId}`,

  // Project Operations
  PROJECT_ARCHIVE: "/projects/archive",

  // =================== COMMISSION SYSTEM ===================
  COMMISSIONS: "/projects/commissions",
  COMMISSIONS_All: "/commissions/referrals",
  // Commission Calculation & Viewing
  COMMISSIONS_ELIGIBLE: "/commissions/eligible",
  COMMISSIONS_PENDING: "/commissions/pending",
  COMMISSIONS_CLAIMED: "/commissions/claimed",
  COMMISSIONS_SUMMARY: "/commissions/summary",
  GLOBAL_USER_REFERRALS_ACTIVITY: "/commissions/referrals/activity",

  // Commission Actions
  COMMISSIONS_CLAIM: "/commissions/claim",
  COMMISSIONS_CLAIM_ALL: "/commissions/claim-all",
  COMMISSIONS_DETAIL: (id) => `/commissions/${id}`,
  COMMISSIONS_CANCEL: (id) => `/commissions/${id}/cancel`,

  // Commission Filtering
  COMMISSIONS_BY_TYPE: (type) => `/commissions/type/${type}`, // blitzpay, project, general
  COMMISSIONS_BY_REFERRAL: (referralId) =>
    `/commissions/referral/${referralId}`,
  COMMISSIONS_HISTORY: "/commissions/history",

  GLOBAL_USER_REFERRAL_ELIGIBLE_COMMISSIONS: (referralId) =>
    `/commissions/referrals/${referralId}/eligible-commissions`,

  GLOBAL_USER_REFERRAL_ACCESS_LIST: "/commissions/referrals/access/list",
  GLOBAL_USER_REFERRAL_ACCESS_DETAIL: (accessId) =>
    `/commissions/referrals/access/${accessId}`,
  COMMISSIONS_ACCESS_CREATE: "/commissions/referrals/access/create",

  GLOBAL_USER_REFERRAL_ACCESS_UPDATE: (accessId) =>
    `/commissions/referrals/access/${accessId}`,
  GLOBAL_USER_REFERRAL_ACCESS_DELETE: (accessId) =>
    `/commissions/referrals/access/${accessId}`,
  GLOBAL_USER_REFERRAL_SPECIFIC_ACCESS: (referralId) =>
    `/commissions/referrals/${referralId}/access`,
  COMMISSIONS_ACCESS_RATE_BREAKDOWN: (accessId) =>
    `/commissions/referrals/access/${accessId}/rate-breakdown`,

  // Available commission types
  COMMISSIONS_TYPES: "/commissions/types",
  COMMISSIONS_MY_ACCESS: "/commissions/referrals/my-access",

  // Commission Admin (if needed)
  ADMIN_COMMISSIONS: "/admin/commissions",
  ADMIN_COMMISSIONS_DETAIL: (id) => `/admin/commissions/${id}`,
  ADMIN_COMMISSIONS_APPROVE: (id) => `/admin/commissions/${id}/approve`,
  ADMIN_COMMISSIONS_STATS: "/admin/commissions/stats",

  // (All other existing endpoints remain the same...)

  // Referral Analytics
  REFERRALS_CREATE: "/commissions/referrals/create",
  REFERRALS_LIST: "/commissions/referrals",
  REFERRALS_GET: (id) => `/commissions/referrals/${id}`,
  REFERRALS_UPDATE_STATUS: (id) => `/commissions/referrals/${id}/status`,
  REFERRALS_DELETE: (id) => `/commissions/referrals/${id}`,
  REFERRALS_STATS: "/commissions/referrals/stats",
  REFERRALS_BY_USER: (userId) => `/commissions/referrals/user/${userId}`,

  // Retroactive Assignment Support
  REFERRALS_SEARCH_USERS: "/commissions/referrals/search-users",
  REFERRALS_USER_DETAILS: (identifier) =>
    `/commissions/referrals/user-details/${identifier}`,
  REFERRALS_VALIDATE_ASSIGNMENT: "/commissions/referrals/validate-assignment",
  REFERRALS_BULK_CREATE: "/commissions/referrals/bulk-create",
  REFERRALS_RETROACTIVE_SUMMARY: "/commissions/referrals/retroactive-summary",
  REQUEST_ACCESS_CRM: "/commissions/referrals/create",

  // Misc Projects
  MISC_PROJECTS: "/projects/misc_projects/fetch",
  MISC_PROJECTS_CREATE: "/projects/misc_projects/create",

  // =================== INVOICING & PAYMENTS ===================
  // Core Invoice Operations
  INVOICES: "/invoices",
  INVOICES_BATCH: "/invoices/batch",
  INVOICES_FILTERS: "/admin/invoices/filters",
  INVOICE_FETCH: (invoiceId) => `/invoice/${invoiceId}`,
  CREATE_INVOICE: "/invoices/create",
  EDIT_INVOICE: "/invoices/editInvoice",
  DELETE_INVOICE: "/invoices/delete",
  INVOICE_CONFIRM: "/invoices/confirm",
  INVOICE_CONFIRM_ALL: "/invoices/confirm",
  INVOICE_PROJECT_FETCH: (invoiceId) => `/invoice/project/${invoiceId}`,
  INVOICE_PARTNERSHIP_FETCH: (invoiceId) => `/invoice/partnership/${invoiceId}`,

  // =================== INVOICE PAYMENT PROCESSING ===================
  // Invoice Payment Options & Processing
  INVOICE_PAYMENT_OPTIONS: (invoiceId) =>
    `/invoices/${invoiceId}/payment-options`,
  INVOICE_PAY_WITH_FUNDS: "/invoices/pay-with-funds",

  INVOICE_PAYMENT_STATUS: (invoiceId) =>
    `/invoices/${invoiceId}/payment-status`,
  INVOICE_EXTERNAL_PO: (invoiceId) => `/invoices/${invoiceId}/external-po`,

  // Invoice Actions
  INVOICE_ACTION: (invoiceId) => `/invoice_action/${invoiceId}`,
  CLIENT_INVOICE_ACTION: (invoiceId) => `/client_invoice_action/${invoiceId}`,
  INVOICE_ACTION_UNITY: (invoiceId) => `/unified_invoice_action/${invoiceId}`,
  INVOICE_SETTINGS: "/invoice-settings",
  CREATOR_INVOICE_SETTINGS: "/creator/invoice-settings",
  PUBLIC_INVOICE_SETTINGS: "/public-invoice-settings",
  BLITZPAY_INVOICE: (invoiceId) => `/blitzpay-invoices/${invoiceId}`,
  BLITZPAY_USER_INVOICES: (userId) => `/blitzpay-invoices/user/${userId}`,
  // =================== USER CUSTOM INFO ENDPOINTS ===================
  // BlitzPay Custom Info - User endpoints
  BLITZPAY_CUSTOM_INFO: "/blitzpay-custom-info",
  // BlitzPay Custom Info - Admin endpoints
  ADMIN_BLITZPAY_CUSTOM_INFO: "/admin/blitzpay-custom-info",
  ADMIN_BLITZPAY_CUSTOM_INFO_DETAIL: (customInfoId) =>
    `/admin/blitzpay-custom-info/${customInfoId}`,
  ADMIN_BLITZPAY_CUSTOM_INFO_BY_USER: (userId) =>
    `/admin/blitzpay-custom-info/user/${userId}`,
  ADMIN_BLITZPAY_CUSTOM_INFO_UPDATE: (customInfoId) =>
    `/admin/blitzpay-custom-info/${customInfoId}`,
  ADMIN_BLITZPAY_CUSTOM_INFO_DELETE: (customInfoId) =>
    `/admin/blitzpay-custom-info/${customInfoId}`,
  ADMIN_BLITZPAY_CUSTOM_INFO_BULK: "/admin/blitzpay-custom-info/bulk-import",
  ADMIN_BLITZPAY_CUSTOM_INFO_STATS: "/admin/blitzpay-custom-info/stats",
  ADMIN_BLITZPAY_PROFILES: "/admin/blitzpay-company-profiles",
  ADMIN_BLITZPAY_PROFILE_DETAIL: (userId) =>
    `/admin/blitzpay-company-profiles/${userId}`,
  ADMIN_BLITZPAY_PROFILE_CREATE_DEFAULT:
    "/admin/blitzpay-company-profiles/create-default",
  // Invoice Admin
  INVOICES_ADMIN: "/admin/invoices",
  SYSTEM_OVERVIEW_METRICS: "/admin/system-overview-metrics",
  CREATOR_INVOICES_ADMIN: "/admin/invoices_creator",
  INVOICE_KPI: "/admin/invoices/kpi",
  EDIT_INVOICES_ADMIN: "/admin/invoice/edit",
  ADMIN_BLITZPAY_INVOICES_MERGE: "/admin/invoices/blitzpay/merge",
  ADMIN_BLITZPAY_INVOICES_MERGE_DISSOLVE: "/admin/invoices/blitzpay/merge/dissolve",

  // Creator Invoicing
  CREATOR_INVOICES: "/incoming_invoices",
  PENDING_INVOICES: (userId) => `/invoices/pending_total?user_id=${userId}`,

  // PayPal Integration
  CREATE_PAYPAL: "/invoices/create_payment",

  // =================== PAYOUT SYSTEM ===================
  // Core Payout Operations
  PAYOUTS: "/payouts",
  PAYOUT_DELETE: "/payouts/delete",
  CREATE_BATCH_PAYOUT: "/payouts/batch",
  PAYOUTS_BY_TOKEN: (token) => `/payouts/token/${token}`,

  // Payout Invitations
  CREATE_INVITE_PAYOUT: "/payouts/invite",
  CREATE_INVITE_PAYOUT_EMAIL: "/payouts/invite_email",
  CONFIRM_INVITE_PAYOUT: (token) => `/payouts/claim/confirm/${token}`,

  // Admin Payout Management
  PAYOUTS_ADMIN: "/admin/payouts",
  PAYOUTS_EDIT_ADMIN: "/admin/payouts/edit",
  DELETE_PAYOUTS_ADMIN: "/admin/payouts/delete",

  // =================== COMPANY MANAGEMENT ===================
  // Core Company Operations
  COMPANY: "/company",
  USERS_COMPANY: "/company/companyusers",
  COMPANY_USERS: (cid) => `/company/${cid}/users`,
  DELETE_COMPANY: "/company/delete",
  FETCH_COMPANY_DATA: "/company/companydata",
  DEMO_REGISTER: "/company/registerdemo",

  // Company Analytics
  COMPANY_INVOICES: (companyId) => `/company/${companyId}/invoices`,
  COMPANIES_INVOICE_SUMMARY: "/companies/invoices/summary",
  COMPANY_ACTIVITY: (companyId) => `/company/${companyId}/activity`,
  UPDATE_LEGAL_ENTITY: (companyId) => `/company/${companyId}/legal-entity`,

  // Company File Management
  COMPANY_FILES: (cid) => `/company/${cid}/files`,

  // Company Team Management
  COMPANY_TEAMS: (cid) => `/admin/companies/${cid}/teams`,
  COMPANY_TEAM: (cid, tid) => `/admin/companies/${cid}/teams/${tid}`,
  COMPANY_REBALANCE_TEAMS: (cid) =>
    `/admin/companies/${cid}/teams/rebalance-credit`,
  COMPANY_TEAM_SPENDING_SUMMARY: (cid) =>
    `/admin/companies/${cid}/teams/credit-summary`,
  COMPANY_TEAM_SPENDING_LEDGER: (cid) =>
    `/admin/companies/${cid}/teams/credit-ledger`,
  TEAM_FILES: (tid) => `/company/team/${tid}/files`,

  // =================== CONVERSATIONS & MESSAGING ===================
  // Conversation Creation
  CONVERSATIONS_CREATE: "/conversations/new",
  CONVERSATIONS_CREATE_CAMPAIGN: "/conversations/campaigns",
  CONVERSATIONS_CREATE_PARTNERSHIP: "/conversations/partnerships",

  // Conversation Management
  CONVERSATIONS_CHECK_CAMPAIGN: "/conversations/check/campaigns",
  CONVERSATIONS_CHECK_PARTNERSHIP: "/conversations/check/partnerships",
  CONVERSATIONS_CHECK_USER_TO_USER: "/conversations/check/user_to_user",
  CONVERSATIONS_CHECK_USER_TO_CREATOR: "/conversations/check/user_to_creator",
  USER_CONVERSATION_CHECK_OR_CREATE:
    "/conversations/user_conversations/check_or_create",

  // Message Operations
  MESSAGES: (id) => `/conversations/messages/${id}`,
  MESSAGES_META: (id) => `/conversations/messages/${id}/metadata`,
  DELETE_MESSAGES: (id) => `/conversations/messages/delete/${id}`,
  MESSAGE_REACTIONS: (messageId) =>
    `/conversations/messages/${messageId}/reactions`,

  // Conversation Retrieval
  CONVERSATIONS_GET_USER_TO_USER: "/conversations/user/sent_conversations",
  CONVERSATIONS_GET_CREATOR_TO_USER: "/conversations/check/creator_to_user",
  USER_CONVERSATION_MESSAGES: (conversationId) =>
    `/conversations/user_conversations/${conversationId}/messages`,
  FETCH_CREATOR_CONVERSATIONS: "/conversations/creator/conversations",
  CONVERSATIONS_GET_BY_CAMPAIGN_AND_CREATOR: (campaignId, creatorId) =>
    `/conversations/campaigns/${campaignId}/creator/${creatorId}/conversation`,

  // Conversation Sharing & Management
  CONVERSATIONS_SHARE_USER_TO_USER: (conversationId) =>
    `/conversations/user_conversations/${conversationId}/share`,
  CONVERSATIONS_SHARE_BY_EMAIL_USER_TO_USER: (conversationId) =>
    `/conversations/user_conversations/${conversationId}/invite_by_email`,
  CONVERSATIONS_UPDATE_NAME_USER_TO_USER: (conversationId) =>
    `/conversations/user_conversations/${conversationId}/update_details`,
  CONVERSATIONS_ADD_PARTICIPANT: (conversationId) =>
    `/conversations/${conversationId}/add-participant`,
  CONVERSATIONS_REMOVE_PARTICIPANT: (conversationId) =>
    `/conversations/${conversationId}/remove-participant`,
  CONVERSATIONS_TRANSFER_HOST: (conversationId) =>
    `/conversations/${conversationId}/transfer-host`,
  // Public Conversations
  CONVERSATIONS_PUBLIC_CONVERSATION: (id) => `/conversations/public/${id}`,
  CONVERSATIONS_PUBLIC_CONVERSATION_JOIN: (id) =>
    `/conversations/public/${id}/join`,

  // Conversation Analytics
  CONVERSATIONS_UNREAD_COUNT_FOR_CAMPAIGN_CREATOR: (campaignId, creatorId) =>
    `/conversations/campaign/${campaignId}/creator/${creatorId}/unread_count`,

  // Admin Conversations
  CONVERSATIONS_GET_ADMIN: "/conversations/admin/fetch",

  CONVERSATIONS_ORGANIZED: "/conversations/organized",
  CONVERSATIONS_STATUS: (id) => `/conversations/${id}/status`,
  CONVERSATIONS_UPDATE_STATUS: (id) => `/conversations/${id}/status`,
  CONVERSATION_ACCEPT: (id) => `/conversations/${id}/accept`,
  CONVERSATIONS_BULK_UPDATE: "/conversations/bulk-update-status",

  // =================== FINANCIAL SYSTEMS ===================
  // Credit Ledger Management
  CREDIT_FETCH: (companyId) => `/bank/credit/ledger/${companyId}`,
  BANK_CREDIT_LEDGER_UPDATE: "/bank/credit/ledger/update",
  BANK_CREDIT_REQUEST: "/bank/credit/request",
  BANK_CREDIT_REQUEST_APPROVE: "/bank/credit/approve",

  // System Liquidity
  BANK_SYSTEM_LIQUID: "/bank/system/liquidity",
  BANK_DEBT_INSTRUMENTS: "/bank/debt/instruments",
  BANK_DEBT_INSTRUMENT: (id) => `/bank/debt/instruments/${id}`,

  //liquduity pools
  CREDIT_LIQUIDITY_POOLS_LIST: "/bank/liquidity/pools",
  CREDIT_LIQUIDITY_POOL: (id) => `/bank/liquidity/pools/${id}`,

  // Balance Management
  BALANCE_LEDGER: (userId) => `/bank/balance/ledger/${userId}`,
  BALANCE_REQUEST: "/bank/balance/request",
  BALANCE_APPROVE: "/bank/balance/approve",
  BALANCE_OPERATION: "/bank/balance/operation",
  BALANCE_ME: "/bank/balance/me",
  BALANCE_PAYMENT_SUCCESS: "/bank/balance/payment-success",
  USER_RESOLVE: (userIdentifier) => `/bank/user/resolve/${userIdentifier}`,
  USER_BALANCE: (userId) => `/users/${userId}/balance`,

  USER_WALLETS: "/bank/wallets",
  USER_WALLET_DETAIL: (walletId) => `/bank/wallets/${walletId}`,
  USER_WALLET_SET_PRIMARY: (walletId) =>
    `/bank/wallets/${walletId}/set_primary`,

  // User Tax Information
  USER_TAX_INFO: "/bank/tax_info",

  // Global User Balance Operations
  GU_BALANCE_INTERNAL_TRANSFER: "/gu-balance/internal-transfer",
  GU_BALANCE_BATCH_TRANSFER: "/gu-balance/batch-transfer",
  GU_BALANCE_EXTERNAL_TRANSFERS: "/gu-balance/external-transfers",
  GU_BALANCE_EXTERNAL_TRANSFER_CANCEL: (id) =>
    `/gu-balance/external-transfers/${id}/cancel`,
  GU_BALANCE_EXTERNAL_TRANSFER_UPDATE: (id) =>
    `/gu-balance/external-transfers/${id}`,
  GU_BALANCE_CLAIM_EXTERNAL_TRANSFER: "/gu-balance/claim-external-transfer",
  GU_BALANCE_T2A_BATCH_TRANSFER: "/gu-balance/t2a-batch-transfer",
  GU_BALANCE_T2A_GIFT: "/gu-balance/t2a-gift",
  GU_BALANCE_T2A_GIFT_SUCCESS: "/gu-balance/t2a-gift/success",
  GU_BALANCE_REQUEST_TRANSFER: '/gu-balance/request-transfer',
  GU_BALANCE_PAY_REQUEST: (token) => `/gu-balance/pay-request/${token}`,
  GU_BALANCE_PAY_REQUEST_CANCEL: (token) => `/gu-balance/pay-request/${token}/cancel`,

  // Spending Power System
  SPENDING_POWER_FUND_INVOICE: (id) => `/credit-line/invoices/${id}/fund`,
  SPENDING_POWER_WITHDRAWAL_ELIGIBILITY: (id) =>
    `/credit-line/invoices/${id}/withdrawal-eligibility`,
  SPENDING_POWER_CREATE_WITHDRAWAL: (id) =>
    `/credit-line/invoices/${id}/create-withdrawal`,
  SPENDING_POWER_SUMMARY: "/credit-line/summary",
  SPENDING_POWER_FUNDED_INVOICES: "/credit-line/funded-invoices",
  SPENDING_POWER_ANALYTICS: "/credit-line/analytics",
  SPENDING_POWER_TEAM_ALLOCATE: (teamId) =>
    `/credit-line/teams/${teamId}/allocate`,
  SPENDING_POWER_TEAM_SUMMARY: (teamId) =>
    `/credit-line/teams/${teamId}/summary`,
  SPENDING_POWER_TEAM_FUNDED_INVOICES: (teamId) =>
    `/credit-line/teams/${teamId}/funded-invoices`,
  SPENDING_POWER_INVOICE_WITHDRAWAL_STATUS: (invoiceId) =>
    `/credit-line/invoices/${invoiceId}/withdrawal-status`,
  SPENDING_POWER_PROCESS_WITHDRAWAL: (invoiceId) =>
    `/credit-line/invoices/${invoiceId}/process-withdrawal`,
  ADMIN_SPENDING_POWER_SUMMARY: (id) =>
    `/admin/credit-line/company/${id}/summary`,
  ADMIN_USER_BALANCE: (userId) => `/admin/users/${userId}/balance`,
  ADMIN_FUND_INVOICE: (id) => `/admin/credit-line/invoices/${id}/fund`,
  BLITZ_SPENDINGPOWER_HISTORY: "/users/spending-power/history",

  // =================== WITHDRAWAL SYSTEM ===================
  // Core Withdrawal Operations
  WITHDRAWAL_REQUEST: "/withdrawals/request",
  WITHDRAWAL_APPROVE: (id) => `/withdrawals/${id}/approve`,
  WITHDRAWAL_PROCESS: (id) => `/withdrawals/${id}/process`,
  WITHDRAWAL_STATUS: (id) => `/withdrawals/${id}/status`,
  WITHDRAWAL_DETAILS: (id) => `/withdrawals/${id}`,
  WITHDRAWAL_LIST: "/withdrawals",
  WITHDRAWAL_BALANCE: "/withdrawals/balance",
  WITHDRAWAL_PAYMENT_SERVICES: "/withdrawals/payment-services",
  WITHDRAWAL_BATCH_PROCESS: "/withdrawals/batch-process",
  WITHDRAWAL_CONVERT_MODE: (id) => `/withdrawals/${id}/convert-mode`,
  WITHDRAWAL_CONVERT_TO_AUTOMATED: (id) =>
    `/withdrawals/${id}/convert-to-automated`,
  WITHDRAWAL_CONVERT_TO_MANUAL: (id) => `/withdrawals/${id}/convert-to-manual`,
  WITHDRAWAL_STATS: "/withdrawals/stats",
  WITHDRAWAL_HEALTH_CHECK: "/withdrawals/health-check",

  // User Withdrawal Operations
  USER_WITHDRAWAL_REQUEST: "/user/withdrawals/request",
  USER_WITHDRAWAL_LIST: "/user/withdrawals",
  USER_WITHDRAWAL_DETAILS: (id) => `/user/withdrawals/${id}`,
  USER_WITHDRAWAL_STATUS: (id) => `/user/withdrawals/${id}/status`,
  USER_WITHDRAWAL_CANCEL: (id) => `/user/withdrawals/${id}/cancel`,
  USER_WITHDRAWAL_HISTORY: "/user/withdrawals/history",
  USER_WITHDRAWAL_LIMITS: "/user/withdrawals/limits",
  USER_WITHDRAWAL_ELIGIBILITY: "/user/withdrawals/eligibility",
  USER_WITHDRAWAL_INSTANT: "/user/withdrawals/instant",

  // Admin Withdrawal Management
  ADMIN_WITHDRAWALS: "/admin/withdrawals",
  ADMIN_WITHDRAWALS_SPEC: (id) => `/admin/withdrawals/${id}`,
  ADMIN_CANCEL_WITHDRAWAL: (id) => `/admin/withdrawals/${id}/cancel`,
  ADMIN_WITHDRAWAL_RETRY: (id) => `/admin/withdrawals/${id}/retry`,
  ADMIN_WITHDRAWAL_RETRY_HISTORY: (id) =>
    `/admin/withdrawals/${id}/retry-history`,
  ADMIN_WITHDRAWAL_RETRY_ELIGIBILITY: (id) =>
    `/admin/withdrawals/${id}/retry-eligibility`,
  ADMIN_WITHDRAWAL_PROCESS_AUTOMATED: (id) =>
    `/admin/withdrawals/${id}/process-automated`,

  // Admin System Config
  ADMIN_SYSTEM_CONFIG: "/admin/system-config",
  ADMIN_SYSTEM_CONFIG_AUTO_PAYMENTS: "/admin/system-config/auto-payments",
  ADMIN_SYSTEM_CONFIG_CLAIM_PAYOUT_AUTOMATION:
    "/admin/system-config/claim-payout-automation",

  // =================== COLLECTIONS SYSTEM ===================
  COLLECTIONS_SUMMARY: "/bank/summary",
  COLLECTIONS_ACTIVE: "/bank/active",
  COLLECTIONS_COMPANY: (companyId) => `/bank/company/${companyId}`,
  COLLECTIONS_DETAIL: (ledgerId) => `/bank/${ledgerId}`,
  COLLECTIONS_BY_INVOICE: (invoiceId) => `/bank/invoice/${invoiceId}`,
  COLLECTIONS_RESOLVE: (ledgerId) => `/bank/${ledgerId}/resolve`,
  COLLECTIONS_CONTACT: (ledgerId) => `/bank/${ledgerId}/contact`,
  COLLECTIONS_AGING_REPORT: "/bank/aging-report",
  COLLECTIONS_TOP_OVERDUE: "/bank/top-overdue",
  COLLECTIONS_OLDEST_OVERDUE: "/bank/oldest-overdue",
  COLLECTIONS_RECENT_RESOLUTIONS: "/bank/recent-resolutions",
  COLLECTIONS_BULK_WRITEOFF: "/bank/bulk-write-off",
  COLLECTIONS_MANUAL_SWEEP: "/bank/manual-sweep",

  // =================== PAYMENT PROCESSING ===================
  // Plaid Integration
  PLAID_CREATE_LINK_TOKEN_CREATOR: "/bank/plaid/create_link_token/creator",
  PLAID_CREATE_LINK_TOKEN_USER: "/bank/plaid/create_link_token/user",
  PLAID_LINK_CREATOR: "/bank/plaid/link/creator",
  PLAID_LINK_USER: "/bank/plaid/link/user",
  PLAID_TRANSACTIONS: "/bank/plaid/transactions",
  PLAID_SEND_TRANSFER: "/bank/plaid/send_transfer",

  // Plaid ACH System
  PLAID_LINK_TOKEN: "/plaid/link-token",
  PLAID_LINK_ACCOUNT: "/plaid/link-account",
  PLAID_BANK_ACCOUNTS: "/plaid/bank-accounts",
  PLAID_CREATE_TRANSFER: "/plaid/create-transfer",
  PLAID_TRANSFER_STATUS: (transferId) => `/plaid/transfer-status/${transferId}`,
  PLAID_WITHDRAWAL_PROCESS: (withdrawalId) =>
    `/plaid/withdrawal/${withdrawalId}/process-ach`,
  PLAID_DEPOSIT_PROCESS: (depositId) =>
    `/plaid/deposit/${depositId}/process-ach`,
  PLAID_BATCH_TRANSFER: "/plaid/batch-transfer",
  PLAID_WEBHOOK: "/plaid/webhook",
  PLAID_HEALTH: "/plaid/health",

  // Stripe ACH Payout
  STRIPE_ACH_ONBOARD_BANK: "/api/stripe-ach/onboard-bank",
  STRIPE_ACH_CHECK_INSTANT: "/api/stripe-ach/check-instant-eligibility",
  STRIPE_ACH_BANK_ACCOUNTS: "/api/stripe-ach/bank-accounts",

  // Stripe Financial Connections (replaces Plaid Link for users/creators)
  STRIPE_FC_CREATE_EXPRESS_ACCOUNT: "/stripe-fc/create-express-account",
  STRIPE_FC_EXPRESS_ONBOARDING_LINK: "/stripe-fc/express-onboarding-link",
  STRIPE_FC_ACCOUNT_STATUS: "/stripe-fc/account-status",
  STRIPE_FC_ONBOARDING_STATUS: "/stripe-fc/onboarding-status",
  STRIPE_FC_CREATE_SESSION: "/stripe-fc/create-session",
  STRIPE_FC_LINK_ACCOUNT: "/stripe-fc/link-account",
  STRIPE_FC_ADD_BANK_TO_CONNECT: "/stripe-fc/add-bank-to-connect",
  STRIPE_FC_CREATE_PLATFORM_SESSION: "/stripe-fc/create-platform-session",
  STRIPE_FC_LINK_PLATFORM_ACCOUNT: "/stripe-fc/link-platform-account",
  STRIPE_FC_MANUAL_BANK: "/stripe-fc/manual-bank",
  STRIPE_FC_RECONCILE_EXTERNAL: "/stripe-fc/reconcile-external-accounts",

  // Wise — international bank account onboarding
  WISE_PROFILE: "/wise/profile",
  WISE_ACCOUNT_REQUIREMENTS: "/wise/account-requirements",
  WISE_ACCOUNT_REQUIREMENTS_REFRESH: "/wise/account-requirements/refresh",
  WISE_RECIPIENTS: "/wise/recipients",
  WISE_RECIPIENT_DETAIL: (id) => `/wise/recipients/${id}`,

  // Stripe Integration
  STRIPE_GET_BANK_ACCOUNTS: "/bank/creator/stripe/bank_accounts",
  STRIPE_LINK: "/bank/creator/stripe/link",
  STRIPE_CREATOR_SETUP_INTENT: "/bank/creator/stripe/setup_intent",
  STRIPE_CREATE_CHECKOUT_SESSION: "/services/stripe/create-checkout-session",
  STRIPE_HANDLE_SUCCESS: "/services/stripe/handle-success",
  STRIPE_WEBHOOK: "/services/stripe/webhook",
  STRIPE_REFUND: "/services/stripe/refund",
  STRIPE_PROCESS_WITHDRAWAL: "/services/stripe/process-withdrawal",

  // =================== COMPANY BANK ACCOUNTS (ADMIN) ===================
  // Company Internal Bank Accounts for ACH Reimbursements (Plaid)
  ADMIN_COMPANY_BANK_LINK_TOKEN: "/admin/company-bank-accounts/link-token",
  ADMIN_COMPANY_BANK_ACCOUNTS: "/admin/company-bank-accounts",
  ADMIN_COMPANY_BANK_ACCOUNTS_BY_COMPANY: (companyId) =>
    `/admin/company-bank-accounts/${companyId}`,
  ADMIN_COMPANY_BANK_ACCOUNT: (accountId) =>
    `/admin/company-bank-accounts/${accountId}`,
  ADMIN_COMPANY_BANK_ACCOUNT_VERIFY: (accountId) =>
    `/admin/company-bank-accounts/${accountId}/verify`,
  // Dwolla Integration
  ADMIN_COMPANY_DWOLLA_STATUS: (companyId) =>
    `/admin/company-bank-accounts/${companyId}/dwolla/status`,
  ADMIN_COMPANY_DWOLLA_ONBOARD: (companyId) =>
    `/admin/company-bank-accounts/${companyId}/dwolla/onboard`,

  // =================== PLATFORM PAYMENT METHODS (ADMIN) ===================
  ADMIN_PLATFORM_PAYMENT_METHODS: "/admin/platform-payment-methods",
  ADMIN_PLATFORM_PAYMENT_METHOD: (methodId) =>
    `/admin/platform-payment-methods/${methodId}`,
  ADMIN_PLATFORM_PAYMENT_METHODS_PLAID_LINK_TOKEN:
    "/admin/platform-payment-methods/plaid/link-token",
  ADMIN_PLATFORM_PAYMENT_METHODS_PLAID: "/admin/platform-payment-methods/plaid",

  // PayPal Integration
  PAYPAL_CREATE_ORDER: "/services/paypal/create-order",
  PAYPAL_CAPTURE_ORDER: "/services/paypal/capture-order",
  PAYPAL_ORDER_STATUS: (orderId) => `/services/paypal/status/${orderId}`,
  PAYPAL_CREATE_PAYOUT: "/services/paypal/create-payout",
  PAYPAL_PAYOUT_STATUS: (batchId) =>
    `/services/paypal/payout-status/${batchId}`,
  PAYPAL_WITHDRAWALS: "/services/paypal/withdrawals",
  PAYPAL_PROCESS_WITHDRAWAL: "/services/paypal/process-withdrawal",
  PAYPAL_WEBHOOK: "/services/paypal/webhook",
  PAYPAL_SUCCESS: "/services/paypal/success",
  PAYPAL_CANCEL: "/services/paypal/cancel",

  // PayPal OAuth (Login with PayPal) - Business Users
  PAYPAL_OAUTH_INITIATE: "/bank/paypal/oauth/initiate",
  PAYPAL_OAUTH_STATUS: "/bank/paypal/oauth/status",
  PAYPAL_OAUTH_DISCONNECT: "/bank/paypal/oauth/disconnect",

  // PayPal OAuth (Login with PayPal) - Creators
  CREATOR_PAYPAL_OAUTH_INITIATE: "/creatorUsers/paypal/oauth/initiate",
  CREATOR_PAYPAL_OAUTH_STATUS: "/creatorUsers/paypal/oauth/status",
  CREATOR_PAYPAL_OAUTH_DISCONNECT: "/creatorUsers/paypal/oauth/disconnect",

  // Stripe OAuth (Stripe Connect) - Business Users
  STRIPE_OAUTH_INITIATE: "/bank/stripe/oauth/initiate",
  STRIPE_OAUTH_STATUS: "/bank/stripe/oauth/status",
  STRIPE_OAUTH_DISCONNECT: "/bank/stripe/oauth/disconnect",

  // Stripe OAuth (Stripe Connect) - Creators
  CREATOR_STRIPE_OAUTH_INITIATE: "/creatorUsers/stripe/oauth/initiate",
  CREATOR_STRIPE_OAUTH_STATUS: "/creatorUsers/stripe/oauth/status",
  CREATOR_STRIPE_OAUTH_DISCONNECT: "/creatorUsers/stripe/oauth/disconnect",

  // =================== DEPOSIT SYSTEM ===================
  DEPOSIT_CREATE: "/api/v9/blitzpay/deposits",
  DEPOSIT_CONFIRM: (depositId) =>
    `/api/v9/blitzpay/deposits/${depositId}/confirm`,
  DEPOSIT_LIST: "/api/v9/blitzpay/deposits",

  // =================== TRANSACTION LINKING ===================
  TRANSACTION_LINKING_CREATE_LINK: "/api/transaction-linking/link",
  TRANSACTION_LINKING_DEPOSIT_WITHDRAWAL:
    "/api/transaction-linking/deposit-withdrawal",
  TRANSACTION_LINKING_GET_LINKS: (transactionId) =>
    `/api/transaction-linking/transaction/${transactionId}/links`,
  TRANSACTION_LINKING_GET_CHAIN: (transactionId) =>
    `/api/transaction-linking/transaction/${transactionId}/chain`,
  TRANSACTION_LINKING_RECONCILE: "/api/transaction-linking/reconcile",
  TRANSACTION_LINKING_BALANCE_TRANSFER:
    "/api/transaction-linking/balance-transfer",
  TRANSACTION_LINKING_ANALYTICS_SUMMARY:
    "/api/transaction-linking/analytics/summary",
  TRANSACTION_LINKING_ANALYTICS_FLOW: "/api/transaction-linking/analytics/flow",
  TRANSACTION_LINKING_BULK_LINK: "/api/admin/transaction-linking/bulk-link",
  TRANSACTION_LINKING_VALIDATE: "/api/admin/transaction-linking/validate",

  // =================== CREATOR ONBOARDING ===================
  CREATOR_PAYMENT_INFO: "/creator/onboarding/payment-info",
  CREATOR_VERIFY_PAYMENT_SETUP: "/creator/onboarding/verify-payment-setup",
  CREATOR_ONBOARDING_PROGRESS: "/creator/onboarding/progress",
  CREATOR_W9_FORM: "/creator/onboarding/w9-form",
  CREATOR_VALIDATE_TAX_ID: "/creator/onboarding/validate-tax-id",
  CREATOR_VALIDATE_BUSINESS_TYPE: "/creator/onboarding/validate-business-type",
  CREATOR_VALIDATE_TAX_CLASSIFICATION:
    "/creator/onboarding/validate-tax-classification",
  ADMIN_CREATOR_ONBOARDING: (id) => `/admin/creator/${id}/onboarding`,
  ADMIN_VERIFY_CREATOR: (id) => `/admin/creator/${id}/onboarding/verify`,

  // =================== FILE MANAGEMENT ===================
  // Core File Operations
  POST_FILES: "/files/upload",
  FETCH_FILES: "/files",
  SPEC_FILE: (id) => `/files/${id}`,
  SPEC_FILE_UPDATE: (id) => `/files/edit/${id}`,
  CREATE_ASSET: "/files/create_asset",
  POST_FILES_CREATOR: "/files/postCreatorFile",
  post_creator_pfp: "/files/upload_onboard_pfp",

  // Contract Files
  CREATE_CONTRACT: "/files/create_contract",
  FETCH_CONTRACTS: "/files/contracts",
  SPEC_CONTRACT: (contract_id) => `/files/contracts/${contract_id}`,

  // Asset Organizers
  ORGANIZERS: "/files/organizers",
  ORGANIZER_DETAIL: (id) => `/files/organizers/${id}`,
  ORGANIZER_FILES: (id) => `/files/organizers/${id}/files`,
  ORGANIZER_FILE_DETAIL: (organizerId, fileId) =>
    `/files/organizers/${organizerId}/files/${fileId}`,
  ORGANIZER_REORDER: (id) => `/files/organizers/${id}/files/reorder`,
  ORGANIZER_FILE_NOTES: (organizerId, fileId) =>
    `/files/organizers/${organizerId}/files/${fileId}/notes`,
  ORGANIZER_ADD_EXISTING: (id) => `/files/organizers/${id}/add-existing-files`,
  ORGANIZER_TYPES: "/files/organizers/types",
  ORGANIZER_UPLOAD: (id) => `/files/organizers/${id}/upload`,

  // Organizer Checklist System
  ORGANIZER_CHECKLIST: (id) => `/files/organizers/${id}/checklist`,
  ORGANIZER_CHECKLIST_ITEM: (organizerId, itemId) =>
    `/files/organizers/${organizerId}/checklist/${itemId}`,
  ORGANIZER_CHECKLIST_FULFILL: (organizerId, itemId) =>
    `/files/organizers/${organizerId}/checklist/${itemId}/fulfill`,
  ORGANIZER_CHECKLIST_UNFULFILL: (organizerId, itemId) =>
    `/files/organizers/${organizerId}/checklist/${itemId}/unfulfill`,
  ORGANIZER_CHECKLIST_REORDER: (organizerId) =>
    `/files/organizers/${organizerId}/checklist/reorder`,
  ORGANIZER_CHECKLIST_BULK: (organizerId) =>
    `/files/organizers/${organizerId}/checklist/bulk`,
  ORGANIZER_CHECKLIST_TEMPLATES: (organizerId) =>
    `/files/organizers/${organizerId}/checklist/templates`,
  ORGANIZER_CHECKLIST_UPLOAD: (organizerId, itemId) =>
    `/files/organizers/${organizerId}/checklist/${itemId}/upload`,

  // Organizer Sharing
  ORGANIZERS_SHARED: "/files/organizers/shared",
  ORGANIZER_SHARE: (id) => `/files/organizers/${id}/share`,
  ORGANIZER_SHARES: (id) => `/files/organizers/${id}/shares`,
  ORGANIZER_SHARE_DETAIL: (organizerId, shareId) =>
    `/files/organizers/${organizerId}/share/${shareId}`,
  ORGANIZER_CREATE_PUBLIC_LINK: (id) => `/files/organizers/${id}/public-link`,
  ORGANIZER_REVOKE_PUBLIC: (id) => `/files/organizers/${id}/revoke-public`,

  // Public Organizer Access
  ORGANIZER_PUBLIC_ACCESS: (id) => `/files/organizers/public/${id}`,
  ORGANIZER_PUBLIC_UPLOAD: (id) => `/files/organizers/public/${id}/upload`,
  ORGANIZER_PUBLIC_CHECKLIST: (id) =>
    `/files/organizers/public/${id}/checklist`,
  ORGANIZER_PUBLIC_CHECKLIST_FULFILL: (id, itemId) =>
    `/files/organizers/public/${id}/checklist/${itemId}/fulfill`,

  // =================== CONTRACT SYSTEM ===================
  // Template Management
  CONTRACTS_TEMPLATES: "/contracts/templates",
  CONTRACTS_TEMPLATE: (id) => `/contracts/templates/${id}`,

  // Assignment Management
  CONTRACTS_ASSIGN: "/contracts/assign",
  CONTRACTS_ASSIGNMENTS: "/contracts/assignments",
  CONTRACTS_ASSIGNMENT: (id) => `/contracts/assignments/${id}`,
  CONTRACTS_ASSIGNMENT_REMIND: (id) => `/contracts/assignments/${id}/remind`,
  CONTRACTS_ASSIGNMENT_DETAILS: (id) => `/contracts/assignments/${id}/details`,

  // Signature Management
  CONTRACTS_SIGN: (id) => `/contracts/sign/${id}`,
  CONTRACTS_AGREE: (id) => `/contracts/agree/${id}`,
  CONTRACTS_DECLINE: (id) => `/contracts/decline/${id}`,
  CONTRACTS_MY_CONTRACTS: "/contracts/my-contracts",
  CONTRACTS_MY_SIGNATURES: "/contracts/my-signatures",
  CONTRACTS_DETAILS: (id) => `/contracts/details/${id}`,

  // Public Contract Access
  CONTRACTS_ACCESS: (id) => `/contracts/access/${id}`,
  CONTRACTS_ACCESS_SIGN: (id) => `/contracts/access/${id}/sign`,
  CONTRACTS_ACCESS_AGREE: (id) => `/contracts/access/${id}/agree`,
  CONTRACTS_ACCESS_DECLINE: (id) => `/contracts/access/${id}/decline`,
  CONTRACTS_ACCESS_TOKEN: (id) => `/contracts/access/${id}/token`,

  // Contract Utilities
  CONTRACTS_VALIDATE_DOCUMENT: "/contracts/validate-document",

  // Contract Analytics
  CONTRACTS_COMPANY_OVERVIEW: (id) => `/contracts/company/${id}/overview`,
  CONTRACTS_TEAM_OVERVIEW: (id) => `/contracts/team/${id}/overview`,
  CONTRACTS_AUDIT: "/contracts/audit",
  CONTRACTS_STATS: "/contracts/stats",

  // Creator Contract Management
  CONTRACTS_CREATORS_ASSIGN_BLITZPAY:
    "/contracts/creators/assign-blitzpay-terms",
  CONTRACTS_CREATOR_BLITZPAY_STATUS: (username) =>
    `/contracts/creators/${username}/blitzpay-status`,

  // External Contract System
  CONTRACTS_EXTERNAL_CREATE: "/contracts/external/create",
  CONTRACTS_EXTERNAL_SIGNATURES: "/contracts/external/signatures",
  CONTRACTS_EXTERNAL_BY_EMAIL: (email) =>
    `/contracts/external/signatures/by-email/${email}`,
  CONTRACTS_EXTERNAL_STATS: "/contracts/external/stats",
  CONTRACTS_EXTERNAL_BLITZPAY_CREATE: "/contracts/external/blitzpay/create",
  CONTRACTS_EXTERNAL_BLITZPAY_BULK: "/contracts/external/blitzpay/bulk",
  CONTRACTS_EXTERNAL_BLITZPAY_STATUS: (email) =>
    `/contracts/external/blitzpay/status/${email}`,
  CONTRACTS_EXTERNAL_GET: (id) => `/contracts/external/${id}`,
  CONTRACTS_EXTERNAL_SIGN: (id) => `/contracts/external/${id}/sign`,
  CONTRACTS_EXTERNAL_AGREE: (id) => `/contracts/external/${id}/agree`,
  CONTRACTS_EXTERNAL_DECLINE: (id) => `/contracts/external/${id}/decline`,
  CONTRACTS_EXTERNAL_VERIFY_EMAIL: "/contracts/external/verify-email",
  CONTRACTS_BLITZPAY_RPA_CHECK: "/contracts/blitzpay-rpa/check", // FIXED: POST endpoint
  CONTRACTS_BLITZPAY_RPA_TEMPLATE: "/contracts/blitzpay-rpa/template", // FIXED: removed /external
  CONTRACTS_BLITZPAY_RPA_CREATE_AND_SIGN:
    "/contracts/blitzpay-rpa/create-and-sign", // FIXED: removed /external
  CONTRACTS_BLITZPAY_RPA_SETUP: "/contracts/templates/setup-blitzpay-rpa",
  CONTRACTS_BLITZPAY_RPA_SIGNED: "/contracts/blitzpay-rpa/signed",
  CONTRACTS_BLITZPAY_RPA_SIGNED_EXPORT: "/contracts/blitzpay-rpa/signed/export",
  CONTRACTS_BLITZPAY_RPA_SIGNED_STATS: "/contracts/blitzpay-rpa/signed/stats",
  CONTRACTS_BLITZPAY_RPA_STATUS: (creatorUsername) =>
    `/contracts/blitzpay-rpa/status/${encodeURIComponent(creatorUsername)}`,

  // Assign RPA to a specific creator (Admin only)
  CONTRACTS_BLITZPAY_RPA_ASSIGN: (creatorUsername) =>
    `/contracts/blitzpay-rpa/assign/${encodeURIComponent(creatorUsername)}`,

  // Resend RPA notification (Admin only)
  CONTRACTS_BLITZPAY_RPA_RESEND: (signatureId) =>
    `/contracts/blitzpay-rpa/resend/${signatureId}`,

  CONTRACTS_USER_TEMPLATES: "/contracts/user/templates",
  CONTRACTS_USER_TEMPLATE_DETAIL: (id) => `/contracts/user/templates/${id}`,
  CONTRACTS_USER_TEMPLATE_CLONE: (id) =>
    `/contracts/user/templates/${id}/clone`,
  CONTRACTS_USER_TEMPLATE_SHARE: (id) =>
    `/contracts/user/templates/${id}/share`,
  CONTRACTS_USER_ASSIGN_EXTERNAL: "/contracts/user/assign-external",
  // User Assignment
  CONTRACTS_USER_ASSIGN: "/contracts/user/assign",
  CONTRACTS_USER_VALIDATE_SCOPE: "/contracts/user/validate-scope",
  CONTRACTS_USER_SEARCH_FOR_ASSIGNMENT: "/contracts/user/search-for-assignment",

  // Add these to the CONTRACTS section
  CONTRACTS_USER_MY_ASSIGNMENTS: "/contracts/user/my-assignments",
  CONTRACTS_USER_MY_ASSIGNMENT_DETAIL: (id) =>
    `/contracts/user/my-assignments/${id}`,
  CONTRACTS_USER_MY_ASSIGNMENT_REMIND: (id) =>
    `/contracts/user/my-assignments/${id}/remind`,
  CONTRACTS_USER_MY_ASSIGNMENT_STATS: "/contracts/user/my-assignments/stats",

  // =================== CRM SYSTEM ===================
  CRM_ADD: "/crm/add",
  CRM_ADD_BULK: "/crm/add-bulk",
  CRM_UPDATE: "/crm/sendupdates",
  CRM_UPDATE_CONTACTS: "/crm/updateContacts",
  CRM_UPDATE_CONTACT_STATUS: "/crm/updateContactStatus",
  CRM_CREATOR_UPDATE_STATUS: "/crm/creator/update_status",
  CRM_CREATOR_CREATORS: "/crm/creator/creators",
  CRM_CREATOR_SPEC: (creatorId) => `/crm/creator/${creatorId}`,
  CRM_IGDM_CREATORS: "/crm/igdm/creators",
  CRM_CONTACTS: "/crm/contacts",
  CONTACTS: "/contacts/",

  // NEW: Lead Qualification System
  CRM_QUALIFIED_LEADS: "/admin/crm/qualified-leads",
  CRM_LEAD_SCORE: (contactId) => `/admin/crm/lead-score/${contactId}`,
  CRM_LEAD_STATS: "/admin/crm/lead-stats",
  CRM_BULK_UPDATE_SCORES: "/admin/crm/bulk-update-lead-scores",

  CRM_PREPARE_CONVERSION: (contactId) =>
    `/admin/crm/prepare-conversion/${contactId}`,
  CRM_CONVERT_TO_CLIENT: (contactId) =>
    `/admin/crm/convert-to-client/${contactId}`,

  // =================== AGENCY MANAGEMENT ===================
  AGENCY_CREATOR: (creatorId) => `/agency/creator/${creatorId}`,
  AGENCY_ZAPFEED: "/agency/zapfeed",
  AGENCY_DASHBOARD: "/agency/dashboard",
  AGENCY_CAMPAIGN_CREATOR_ACCEPT: (campaignId) =>
    `/agency/campaigns/${campaignId}/accept`,
  AGENCY_CAMPAIGN_CREATOR_UPDATE_FIELDS: (campaignId) =>
    `/agency/campaigns/${campaignId}/update_fields`,
  AGENCY_CAMPAIGN_NEGOTIATE: (campaignId) =>
    `/agency/campaigns/${campaignId}/negotiate`,
  AGENCY_ROSTER_SETTINGS: (agencyName) =>
    `/agency/${agencyName}/rosterSettings`,
  PUBLIC_AGENCY_ROSTER_SETTINGS: (agencyName) =>
    `/agency/publicRosterSettings/${agencyName}`,
  AGENCY_PAYOUT_APPROVE: (payoutId) => `/agency/payouts/${payoutId}/approve`,
  AGENCY_PAYOUTS: "/agency/payouts",
  AGENCY_ALL_COLLABS: "/agency/all-collaborations",
  AGENCY_CREATOR_ACTIVITY: (creatorId) =>
    `/agency/creators/${creatorId}/activity`, // ADD THIS
  AGENCY_ALL_MONEY: "/agency/money", // This already exists
  AGENCY_CLAIM_INVOICE: (invoiceId) => `/agency/invoices/${invoiceId}/claim`, // NEW
  AGENCY_CLAIMABLE_INVOICES: "/agency/claimable-invoices", // ADD THIS LINE
  // =================== CLIENT MANAGEMENT ===================
  CLIENTS_ADD: "/admin/clients/add",
  CLIENTS: "/admin/clients/fetch",
  CREATE_SUP_CLIENT: "/admin/clients/supervisor_add",
  UPDATE_CLIENT: (clientid) => `/users/clients/${clientid}`,

  CLIENT_CAMPAIGNS: (clientid) => `/admin/clients/${clientid}/campaigns`,
  CLIENT_NOTES: (clientId) => `/users/${clientId}/notes`,
  CLIENT_NOTE: (noteId) => `/users/notes/${noteId}`,
  DELETE_SUP_CLIENT: (clientId) => `/users/${clientId}/delete`,

  // ─────────────────────────────────────────────────────────────────────────────
  // PASTE THESE BLOCKS INTO endpoints.js
  // Find the section "// ── Client / Creator Reminders" and paste directly after it.
  // ─────────────────────────────────────────────────────────────────────────────

  // ── Client Todos ──────────────────────────────────────────────────────────────
  CLIENT_TODOS: (clientId) => `/users/clients/${clientId}/todos`,
  CLIENT_TODO_REORDER: (clientId) => `/users/clients/${clientId}/todos/reorder`,
  CLIENT_TODO_STATS: (clientId) => `/users/clients/${clientId}/todos/stats`,
  CLIENT_TODO: (todoId) => `/users/todos/${todoId}`,
  CLIENT_TODO_TOGGLE: (todoId) => `/users/todos/${todoId}/toggle`,

  // ── Creator Todos (mirrors client pattern) ────────────────────────────────────
  CREATOR_TODOS: (creatorId) => `/users/creators/${creatorId}/todos`,
  CREATOR_TODO_REORDER: (creatorId) =>
    `/users/creators/${creatorId}/todos/reorder`,
  CREATOR_TODO_STATS: (creatorId) => `/users/creators/${creatorId}/todos/stats`,

  // ── AM Priority Ranking ────────────────────────────────────────────────────────
  AM_RANKING: "/users/am-ranking",
  AM_RANKING_ADD: "/users/am-ranking/add",
  AM_RANKING_REORDER: "/users/am-ranking/reorder",
  AM_RANKING_REMOVE: (clientId) => `/users/am-ranking/remove/${clientId}`,

  GET_CREATOR_NOTES: (creatorId) => `/users/creators/${creatorId}/notes`,
  POST_CREATOR_NOTE: (creatorId) => `/users/creators/${creatorId}/notes`,
  UPDATE_CREATOR_NOTE: (noteId) => `/users/creators/notes/${noteId}`,
  DELETE_CREATOR_NOTE: (noteId) => `/users/creators/notes/${noteId}`,

  // Supervisor Management
  GET_SUPERVISED: "/users/supervisor/projects",
  SUPERVISOR_COMPANIES: "/users/supervisor/projects2?section=companies",
  SUPERVISOR_CREATORS: "/users/supervisor/projects2?section=creators",
  SUPERVISOR_CAMPAIGNS: "/users/supervisor/projects2?section=campaigns",
  ALL_CLIENTS: "/users/supervisor/clients",
  SUPERVISOR_CLIENTS: "/users/supervisor/clients",
  TOGGLE_CLIENT_STAR: (clientId) =>
    `/users/supervisor/clients/${clientId}/star`,
  GET_CLIENT_DETAILS: (clientId) =>
    `/users/supervisor/clients/${clientId}/details`,
  TOGGLE_CLIENT_ARCHIVE: (clientId) =>
    `/users/supervisor/clients/${clientId}/archive`,
  ARCHIVED_CLIENTS: "/users/supervisor/clients/archived",

  SHARE_CLIENT: (clientId) => `/users/clients/${clientId}/share`,
  UNSHARE_CLIENT: (clientId) => `/users/clients/${clientId}/unshare`,
  CLIENT_SHARING_INFO: (clientId) => `/users/clients/${clientId}/sharing-info`,

  CLIENT_NOTE_THREADS: (clientId) => `/users/${clientId}/notes/threads`,
  CLIENT_NOTE_REPLY: (clientId, noteId) =>
    `/users/${clientId}/notes/${noteId}/reply`,

  CLIENT_GROUPS: "/users/groups",
  CLIENT_GROUPS_TREE: "/users/groups/tree",
  CLIENT_GROUP: (groupId) => `/users/groups/${groupId}`,
  CLIENT_GROUP_SHARE: (groupId) => `/users/groups/${groupId}/share`,
  CLIENT_GROUP_UNSHARE: (groupId) => `/users/groups/${groupId}/unshare`,
  CLIENT_GROUP_MEMBERS: (groupId) => `/users/groups/${groupId}/members`,
  CLIENT_GROUP_MEMBER: (groupId, clientId) =>
    `/users/groups/${groupId}/members/${clientId}`,

  SUPERVISOR_TEAM_MEMBERS: "/users/supervisor/team-members",
  BULK_SHARE_CLIENTS: "/users/clients/bulk-share",

  // ── Client / Creator Reminders ────────────────────────────────────────────────
  CLIENT_REMINDERS: "/users/reminders",
  CLIENT_REMINDERS_DUE: "/users/reminders/due",
  CLIENT_REMINDER: (reminderId) => `/users/reminders/${reminderId}`,
  CLIENT_REMINDER_SNOOZE: (reminderId) =>
    `/users/reminders/${reminderId}/snooze`,
  CLIENT_REMINDER_COMPLETE: (reminderId) =>
    `/users/reminders/${reminderId}/complete`,

  // Creator Notes - Threaded System
  CREATOR_NOTE_THREADS: (creatorId) =>
    `/users/creators/${creatorId}/notes/threads`,
  CREATOR_NOTE_REPLY: (creatorId, noteId) =>
    `/users/creators/${creatorId}/notes/${noteId}/reply`,

  // =================== TRACKING & ANALYTICS ===================
  CREATE_TRACKERS: "/trackers/",
  FETCH_TRACKERS: "/trackers/",
  FETCH_TRACKER: (id) => `/trackers/${id}`,
  FETCH_TRACKER_PUBLIC: (id) => `/trackers/public/${id}`,
  UPDATE_TRACKERS: (id) => `/trackers/${id}`,
  DELETE_TRACKER: (id) => `/trackers/${id}`,
  STOP_TRACKER: (trackerId) => `/trackers/${trackerId}/stop`,
  EXPORT_SHEET_TRACKER: (id) => `/trackers/${id}/export`,
  GET_TRACKER_HISTORY: (id) => `/trackers/${id}/history`,
  GET_TRACKER_HISTORY_PUBLIC: (id) => `/trackers/public/${id}/history`,
  TRACKER_SHARES:        (id) => `/trackers/${id}/shares`,
TRACKER_SHARE_USER:    (id, shareUserId) => `/trackers/${id}/shares/${shareUserId}`,
TRACKER_SHARED_WITH_ME: '/trackers/shared',

  EXPORT_SHEET: "/export_to_sheets",
  EXPORT_SHEET_CREATORS: "/export_creator_data",

  // =================== SOCIAL FEATURES ===================
  // Social Following
  SOCIAL_FOLLOW: "/social/follow",
  SOCIAL_UNFOLLOW: "/social/unfollow",
  FETCH_FOLLOWERS: "/social/followers",
  FETCH_FOLLOWING: "/social/following",
  SOCIAL_IS_FOLLOWING: "/social/is_following",

  // ZapFeed V3
  ZAPFEED_V3: "/zapfeed3",
  ZAPFEED_POST: "/zapfeed3/post",
  ZAPFEED_REACTIONS: (postId) => `/zapfeed3/posts/${postId}/reactions`,
  ZAPFEED_CREATE_REPLY: (postId) => `/zapfeed3/posts/${postId}/reply`,
  ZAPFEED_GET_REPLIES: (postId) => `/zapfeed3/posts/${postId}/replies`,
  ZAPFEED_GET_THREAD: (postId) => `/zapfeed3/posts/${postId}/thread`,
  ZAPFEED_PUBLIC_THREAD: (postId) => `/zapfeed3/public/posts/${postId}/thread`,
  ZAPFEED_PUBLIC_SHARE: (postId) => `/zapfeed3/public/posts/${postId}/share`,

  // Legacy ZapFeed
  USERS_ZAPFEED: "/fetchzapfeed",

  // =================== BIO PAGES ===================
  BIO: "/bio/",
  BIO_AGENCY: "/bio/agency/",
  PUBLIC_BIO: "/bio/fetch",
  BIO_CONTACTS: "/bio/contacts/", // NEW: Get available contacts for bio linking

  // =================== COMMUNICATION ===================
  // Email Campaigns
  ADMIN_CAMPAIGNS: "/internalCampaigns",
  ADMIN_CAMPAIGN_DETAIL: (id) => `/internalCampaigns/${id}`,
  ADMIN_CAMPAIGN_ANALYTICS: (id) => `/internalCampaigns/${id}/analytics`,
  ADMIN_CAMPAIGN_RECIPIENTS: (id) => `/internalCampaigns/${id}/recipients`,
  ADMIN_CAMPAIGN_TEST: (id) => `/internalCampaigns/${id}/test`,
  ADMIN_CAMPAIGNS_TEMPLATES: "/internalCampaigns/templates",
  ADMIN_CAMPAIGNS_TEMPLATE: (id) => `/internalCampaigns/templates/${id}`,
  ADMIN_CAMPAIGNS_TYPES: "/internalCampaigns/types",
  ADMIN_CAMPAIGNS_AUDIENCE_TYPES: "/internalCampaigns/audience_types",

  // =================== CREATOR ADMIN UPDATES (PARTITIONED) ===================
  ADMIN_CREATOR_UPDATE_BASIC: (creatorId) =>
    `/admin/creators/${creatorId}/basic`,
  ADMIN_CREATOR_UPDATE_CONTACT: (creatorId) =>
    `/admin/creators/${creatorId}/contact`,
  ADMIN_CREATOR_UPDATE_PLATFORMS: (creatorId) =>
    `/admin/creators/${creatorId}/platforms`,
  ADMIN_CREATOR_UPDATE_DEMOGRAPHICS: (creatorId) =>
    `/admin/creators/${creatorId}/demographics`,
  ADMIN_CREATOR_UPDATE_ADDITIONAL: (creatorId) =>
    `/admin/creators/${creatorId}/additional`,

  // SMS & Communication
  TWILIO_SEND_CREATOR_SMS: "/sendCreatorSMS",
  FETCH_MESSAGES: "/admin/textmessages/fetch",

  // Blocklist Management
  BLOCKLIST: "/blocklist",
  BLOCKED_CONTACT: (email) => `/blocklist/${email}`,

  // =================== CASTING CALLS SYSTEM (ENHANCED) ===================
  // Brand/User Routes (Create & Manage)
  CASTING_CALLS_LIST: "/castingcalls/list",
  CASTING_CALLS_POST_NEW: "/castingcalls/postNew",
  CASTING_CALL_DETAIL: (id) => `/castingcalls/${id}`,
  CASTING_CALL_INVITE: (id) => `/castingcalls/${id}/invite`,
  CASTING_CALL_SELECT: (id) => `/castingcalls/${id}/select`,
  CASTING_CALL_UPDATE_STATUS: (id) => `/castingcalls/${id}/status`,

  // Creator Routes (Browse & Apply)
  CASTING_CALLS_CREATOR_BROWSE: "/castingcalls/creator/browse",
  CASTING_CALLS_CREATOR_APPLY: (id) => `/castingcalls/creator/apply/${id}`,

  // General User Routes (Browse & Apply)
  CASTING_CALLS_GENERAL_BROWSE: "/castingcalls/general/browse",
  CASTING_CALLS_GENERAL_APPLY: (id) => `/castingcalls/general/apply/${id}`,

  // Public Routes
  CASTING_CALL_PUBLIC: (slug) => `/castingcalls/public/${slug}`,

  // Utility Routes
  CASTING_CALLS_WORK_TYPES: "/castingcalls/work-types",

  CASTING_CALL_ORGANIZERS: (id) => `/castingcalls/${id}/organizers`,

  // Legacy endpoints (keep for backwards compatibility)
  CASTING_CALLS_UPDATE_STATUS: "/castingcalls/updateStatus",
  creatorCastingCalls: "/castingcalls/active",
  CASTING_CREATOR_APPLY: "/castingcalls/apply",
  CASTING_CALL_SPEC: (id) => `/castingcalls/${id}`,

  CASTING_CALL_PUBLIC_ORGANIZERS: (slug) =>
    `/castingcalls/public/${slug}/organizers`,
  // In API_ENDPOINTS object:
  CASTING_CALLS_AGENCY_APPLY: (id) =>
    `/castingcalls/creator/apply-agency/${id}`,
  CASTING_CALLS_CHECK_AGENCY: (slug) =>
    `/castingcalls/public/${slug}/check-agency`,

  CASTING_CALLS_MY_MANAGED: "/castingcalls/my-managed",

  CASTING_CALL_UPDATE_BUDGET: (id) => `/castingcalls/${id}/budget`,
  CASTING_CALL_ASSIGN_PAYOUT: (id) => `/castingcalls/${id}/payout`,
  CASTING_CALL_ISSUE_PAYMENT: (id) => `/castingcalls/${id}/payment`,

  CASTING_CALL_ASSIGN_ORGANIZER: (castingCallId, organizerId) =>
    `/castingcalls/${castingCallId}/organizers/${organizerId}/assign`,
  CASTING_CALL_REJECT: (id) => `/castingcalls/${id}/reject`,
  CASTING_CALL_ASSIGN_PAYOUT: (id) => `/castingcalls/${id}/assign-payout`,
  CASTING_CALL_CONVERSATIONS_CHECK: (id) =>
    `/castingcalls/${id}/conversations/check`,
  CASTING_CALL_CONVERSATIONS_CREATE: (id) =>
    `/castingcalls/${id}/conversations/create`,
  CASTING_CALLS_CREATOR_APPLICATIONS: "/castingcalls/creator/my-applications",

  // =================== CASTING CALLS PAYOUT MANAGEMENT ===================
  // Budget Management
  CASTING_CALL_BUDGET_VALIDATE: (id) => `/castingcalls/${id}/budget/validate`,
  CASTING_CALL_BUDGET_STATUS: (id) => `/castingcalls/${id}/budget/status`,

  // Payout Operations
  CASTING_CALL_PAYOUTS: (id) => `/castingcalls/${id}/payouts`,
  CASTING_CALL_PAYOUT_APPROVE: (payoutId) =>
    `/castingcalls/payouts/${payoutId}/approve`,
  CASTING_CALL_PAYOUT_CANCEL: (payoutId) => `/castingcalls/payouts/${payoutId}`,

  // Budget Management
  CASTING_CALL_BUDGET_VALIDATE: (id) => `/castingcalls/${id}/budget/validate`,

  CASTING_CALL_UPDATE: (id) => `/castingcalls/${id}`,

  // Deal IOs
  DEAL_IOS: "/deals_io",
  DEAL_IO_DETAIL: (dealIOId) => `/deals_io/${dealIOId}`,
  DEAL_IO_COPY: (dealIOId) => `/deals_io/${dealIOId}/copy`,
  DEAL_IO_SHARE: (dealIOId) => `/deals_io/${dealIOId}/share`,
  CREATOR_DEAL_FETCH: "/deals_io/creators/fetch",
  CREATOR_DEAL_IO_DETAIL: (dealIOId) => `/deals_io/creators/${dealIOId}`,

  // =================== COLLECTIONS & SEARCH ===================
  collections: "/collections/list",
  collections_post: "/collections/post",
  collections_delete: (id) => `/collections/${id}`,
  collectionsPopular: "/collections/popular",
  CREATOR_SEARCH: "/collections/search",
  FETCH_SIMILAR: "/creators",

  // =================== DEVELOPER & THIRD PARTY ===================
  DEVELOPER_SERVICE: "/thirdparty/services",
  DEVELOPER_KEY: "/thirdparty/apikeys",
  DEVELOPER_SERVICE_SPEC: (id) => `/thirdparty/services/${id}`,
  DEVELOPER_KEY_SPEC: (id) => `/thirdparty/apikeys/${id}`,
  DEVELOPER_SERVICE_PUBLIC: "/apps",
  DEVELOPER_SERVICE_PUBLIC_SPEC: (id) => `/apps/${id}`,
  DEVELOPER_SERVICE_SUBBED: (id) => `/apps/${id}/subscription`,
  DEVELOPER_SERVICE_LOG: (id) => `/apps/${id}/log`,
  DEVELOPER_SERVICE_UPDATE: (id) => `/apps/${id}/update`,

  // =================== SURVEYS & ACHIEVEMENTS ===================
  // Survey System
  LIST_SURVEYS: "/survey",
  CREATE_SURVEY: "/survey",
  LIST_PENDING_SURVEY: (userId) => `/survey/pending/${userId}`,
  CREATE_SURVEY_RESPONSE: "/survey/responses",
  UPDATE_SURVEY: (surveyId) => `/survey/${surveyId}`,
  DELETE_SURVEY: (surveyId) => `/survey/${surveyId}`,
  GET_SURVEY_RESPONSES: (surveyId) => `/survey/responses/${surveyId}`,

  // BlitzBolts Achievement System
  LIST_BLITZBOLTS: "/blitzbolts",
  CREATE_BLITZBOLT: "/blitzbolts",
  LIST_BLITZBOLTS_FOR_USER: (userId) => `/blitzbolts/for_user/${userId}`,
  GET_BLITZBOLT_ACHIEVEMENT: (userId, attainmentId) =>
    `/blitzbolts/${userId}/${attainmentId}`,
  SHARE_BLITZBOLT: (userId, attainmentId) =>
    `/blitzbolts/${userId}/${attainmentId}`,
  BLITZBOLTS_LEADERBOARD: "/blitzbolts/leaderboard",

  // =================== CREDIT & MARKETING ===================
  CREDX_CREDITS: "/credx/credits",
  SUBTRACT_CREDITS: "/credx/subtract_credits",

  // NOA ROUTES
  NOA: "/noa",
  NOA_PENDING: (creatorId) => `/noa/pending/${creatorId}`,
  NOA_ACKNOWLEDGE: "/noa/acknowledge",
  NOA_ACKNOWLEDGED: (creatorId) => `/noa/acknowledged/${creatorId}`,
  NOA_SEND: (noaId) => `/noa/${noaId}/send`,
  NOA_REVOKE: (noaId) => `/noa/${noaId}/revoke`,
  NOA_CHECK: "/noa/check",
  NOA_LINK_INVOICE: "/noa/link_invoice",
  NOA_PUBLIC_VIEW: (token) => `/noa/public/view/${token}`,
  NOA_PUBLIC_ACKNOWLEDGE: (token) => `/noa/public/acknowledge/${token}`,

  ARTICLES_LIST: "/articles",
  ARTICLES_DETAIL: (slug) => `/articles/${slug}`,
  ARTICLES_FEATURED: "/articles/featured",
  ARTICLES_CATEGORIES: "/articles/categories",
  ARTICLES_TAGS: "/articles/tags",

  // Add these lines to your API_ENDPOINTS in endpoints.js
  // Find the BUBBLES section and add these new endpoints:

  // =================== BUBBLES (COMMUNITIES) ===================
  // Core Bubble Operations
  BUBBLES_LIST: "/bubbles",
  BUBBLES_CREATE: "/bubbles",
  BUBBLE_DETAIL: (id) => `/bubbles/${id}`,
  BUBBLE_UPDATE: (id) => `/bubbles/${id}`,
  BUBBLE_DELETE: (id) => `/bubbles/${id}`,

  // Bubble Membership
  BUBBLE_JOIN: (id) => `/bubbles/${id}/join`,
  BUBBLE_LEAVE: (id) => `/bubbles/${id}/leave`,
  BUBBLE_ADD_MEMBER: (id) => `/bubbles/${id}/members`,
  BUBBLE_REMOVE_MEMBER: (id, memberId) => `/bubbles/${id}/members/${memberId}`,

  // Bubble Admins
  BUBBLE_ADD_ADMIN: (id, adminId) => `/bubbles/${id}/admins/${adminId}`,
  BUBBLE_REMOVE_ADMIN: (id, adminId) => `/bubbles/${id}/admins/${adminId}`,

  // Bubble Settings (NEW - matches your Python routes)
  BUBBLE_SETTINGS: (id) => `/bubbles/${id}/settings`,
  BUBBLE_MEMBERSHIP_STATUS: (id) => `/bubbles/${id}/membership-status`,

  // Bubble Feed & Posts
  BUBBLE_FEED: (id) => `/bubbles/${id}/feed`,
  BUBBLE_FEED_PUBLIC: (id) => `/bubbles/${id}/feed/public`,
  BUBBLE_CREATE_POST: (id) => `/bubbles/${id}/posts`,

  // Bubble Discovery
  BUBBLES_DISCOVER: "/bubbles/discover",
  BUBBLE_USER_SUMMARY: (userId) => `/bubbles/user/${userId}/summary`,

  // Bubble Conversation
  BUBBLE_CONVERSATION: (id) => `/bubbles/${id}/conversation`,
  BUBBLE_CONVERSATION_PARTICIPANTS: (id) =>
    `/bubbles/${id}/conversation/participants`,

  // Bubble Organizers
  BUBBLE_ORGANIZERS_LIST: (id) => `/bubbles/${id}/organizers`,
  BUBBLE_ORGANIZERS_CREATE: (id) => `/bubbles/${id}/organizers`,
  BUBBLE_ORGANIZER_SETTINGS: (id, organizerId) =>
    `/bubbles/${id}/organizers/${organizerId}/settings`,
  BUBBLE_ORGANIZER_REMOVE: (id, organizerId) =>
    `/bubbles/${id}/organizers/${organizerId}`,

  // Public Bubble Endpoints (no auth required)
  BUBBLE_PUBLIC_DETAIL: (id) => `/bubbles/${id}/public`,
  BUBBLE_PUBLIC_ASSETS: (id) => `/bubbles/${id}/assets/public`,

  BUBBLE_ORGANIZER_SHARE: (id, organizerId) =>
    `/bubbles/${id}/organizers/${organizerId}/share`,
  BUBBLE_ORGANIZER_SHARES: (id, organizerId) =>
    `/bubbles/${id}/organizers/${organizerId}/shares`,

  // Admin Article Routes (require ADMIN_LEVEL auth)
  ADMIN_ARTICLES_LIST: "/admin/articles",
  ADMIN_ARTICLES_DETAIL: (id) => `/admin/articles/${id}`,
  ADMIN_ARTICLES_CREATE: "/admin/articles",
  ADMIN_ARTICLES_UPDATE: (id) => `/admin/articles/${id}`,
  ADMIN_ARTICLES_DELETE: (id) => `/admin/articles/${id}`,
  ADMIN_ARTICLES_PUBLISH: (id) => `/admin/articles/${id}/publish`,
  ADMIN_ARTICLES_UNPUBLISH: (id) => `/admin/articles/${id}/unpublish`,
  ADMIN_ARTICLES_DUPLICATE: (id) => `/admin/articles/${id}/duplicate`,

  // Admin Article Categories
  ADMIN_CATEGORIES_LIST: "/admin/articles/categories",
  ADMIN_CATEGORIES_CREATE: "/admin/articles/categories",
  ADMIN_CATEGORIES_UPDATE: (id) => `/admin/articles/categories/${id}`,
  ADMIN_CATEGORIES_DELETE: (id) => `/admin/articles/categories/${id}`,

  ADMIN_AM_METRICS: "/admin/metrics",
  ADMIN_AM_METRICS_SPEC: (id) => `/admin/metrics/${id}/details`,

  // =================== BLITZ AI SYSTEM ===================
  // Partner Creator Email Management
  BLITZAI_PARTNER_STATUS: "/admin/creators/partners/status",
  BLITZAI_CHECK_EMAILS: "/admin/creators/partners/check-emails",
  BLITZAI_PROCESS_EMAILS: "/admin/creators/partners/process-emails",
  BLITZAI_PROCESS_FOLLOWUPS: "/admin/creators/partners/process-followups",
  BLITZAI_PROCESS_FORWARDED: "/admin/creators/partners/process-forwarded",
  BLITZAI_CREATOR_EMAILS: (username) =>
    `/admin/creators/partners/${username}/emails`,
  // NEW: Classification Monitoring & Management
  BLITZAI_CLASSIFICATION_STATS: "/admin/monitoring/classification-stats",
  BLITZAI_TEST_CLASSIFY: "/admin/creators/partners/test-classify",
  BLITZAI_RECLASSIFY_EMAIL: (emailId) =>
    `/admin/creators/partners/emails/${emailId}/reclassify`,
  BLITZAI_BULK_RECLASSIFY: "/admin/creators/partners/emails/bulk-reclassify",
  BLITZAI_CLASSIFIER_CONFIG: "/admin/monitoring/classifier-config",
  BLITZAI_EMAIL_DEBUG: (username) =>
    `/admin/creators/partners/${username}/email-check-debug`,
  BLITZAI_TOGGLE_EMAIL_HIDDEN: (emailId) =>
    `/admin/creators/partners/emails/${emailId}/toggle-hidden`,
  BLITZAI_BULK_HIDE_EMAILS: "/admin/creators/partners/emails/bulk-hide",
  BLITZAI_EMAIL_THREAD: (emailId) =>
    `/admin/creators/partners/emails/${emailId}/thread`,
  BLITZAI_CREATOR_THREADS: (username) =>
    `/admin/creators/partners/${username}/threads`,
  BLITZAI_REPLY_STATS: "/admin/creators/partners/replies/stats",
  BLITZAI_RECLASSIFY_EMAIL_V2: (email_id) =>
    `/admin/creators/partners/emails/${email_id}/reclassify`,
  BLITZAI_RECLASSIFICATION_HISTORY: (email_id) =>
    `/admin/creators/partners/emails/${email_id}/reclassification-history`,

  // BlitzPay Invoice Repayment Management (Admin)
  BLITZPAY_REPAYMENTS_PROCESS: "/admin/blitzpay/repayments",
  BLITZPAY_REPAYMENTS_BATCH: "/admin/blitzpay/repayments/batch",
  BLITZPAY_REPAYMENTS_VALIDATE: (invoiceId) =>
    `/admin/blitzpay/repayments/validate/${invoiceId}`,
  BLITZPAY_REPAYMENTS_PENDING: "/admin/blitzpay/repayments/pending",

  // Admin User Balances
  ADMIN_USER_BALANCES: "/admin/user-balances",
  ADMIN_USER_BALANCE_LEDGER: (userId) =>
    `/admin/user-balances/${userId}/ledger`,
  ADMIN_T2_HISTORY: "/admin/user-balances/t2-history",
  ADMIN_RESOLVER_PAYOUTS: "/admin/resolver/payouts",
  ADMIN_RESOLVER_USERS:   "/admin/resolver/users",
  ADMIN_RESOLVER_RESOLVE: "/admin/resolver/resolve",
  ADMIN_USER_BALANCE_ZERO: (userId) => `/admin/user-balances/${userId}/zero`,


  // BlitzPay Merge
  BLITZPAY_INVOICES_MERGE: "/v9/blitzpay/invoices/merge",

    /** PUT  /users/clients/:id/bap  — set or clear the BAP tier */
  CLIENT_BAP: (clientId) => `/users/clients/${clientId}/bap`,
 
  /** GET  /users/supervisor/clients/bap  — all BAP clients visible to caller */
  SUPERVISOR_BAP_CLIENTS: "/users/supervisor/clients/bap",
 
  /** GET  /users/supervisor/clients/bap/summary  — tier counts only (for tab badge) */
  SUPERVISOR_BAP_SUMMARY: "/users/supervisor/clients/bap/summary",

  // ── BAP Client Links ───────────────────────────────────────────────────────────
  BAP_CLIENT_LINKS:        (bapClientId) => `/users/clients/${bapClientId}/linked`,
  BAP_CLIENT_LINK_REMOVE:  (bapClientId, linkedClientId) =>
    `/users/clients/${bapClientId}/linked/${linkedClientId}`,
  BAP_LINK_UPDATE:         (linkId) => `/users/bap-links/${linkId}`,
  BAP_CLIENT_LINK_MOVE:    (bapClientId) => `/users/clients/${bapClientId}/linked/move`,
  BAP_LINKED_COUNTS:       "/users/supervisor/clients/bap/linked-counts",

  BBC_CREATE: "/bbc/create",
  BBC_INCOMING: "/bbc/incoming",
  BBC_PAYMENT_DECISION: (paymentId) => `/bbc/payments/${paymentId}/decision`,
  BBC_PAYMENT_BY_TOKEN: (token) => `/bbc/payments/token/${token}`,
  BBC_MARK_FUNDED: (bbcId) => `/bbc/${bbcId}/mark-funded`,
 
  // Split directory (NEW)
  BBC_COMPANIES: "/bbc/companies",                                  // ?search=&limit=
  BBC_COMPANY_CONTACTS: (companyId) => `/bbc/companies/${companyId}/contacts`,


  CLIENT_SALES_STAGE: (clientId) => `/users/clients/${clientId}/sales-stage`,
 
  // GET  /users/supervisor/clients/pipeline-summary  — per-stage badge counts
  PIPELINE_SUMMARY: "/users/supervisor/clients/pipeline-summary",

  BBC_CONVERT_TO_BLITZPAY: (id) => `/bbc/${id}/convert-to-blitzpay`,

  BBC_UPDATE_PAYMENTS:  (bbcId)     => `/bbc/${bbcId}/payments`,
  BBC_WITHDRAW_MARGIN:  (bbcId)     => `/bbc/${bbcId}/withdraw-margin`,
  BBC_CANCEL_PAYMENT:   (paymentId) => `/bbc/payments/${paymentId}/cancel`,
  BBC_REMAINING:        (bbcId)     => `/bbc/${bbcId}/remaining`,

  // ── Blitz Commerce (Alpha) ─────────────────────────────────────────────────
  COMMERCE_PRODUCTS: "/commerce/products",
  COMMERCE_METRICS: "/commerce/metrics",
  COMMERCE_PURCHASERS: "/commerce/purchasers",
  COMMERCE_RETURNS: "/commerce/returns",
  // Bulk-import historical orders from an external store (e.g. a WooCommerce
  // sales export) — see docs/cummerce/crm-commerce-mapping.md. Distinct from
  // live checkout: imported rows must NOT trigger live ledger crediting,
  // since that revenue already settled outside Blitz.
  COMMERCE_ORDERS_IMPORT: "/commerce/orders/import",

  // Public (no auth) — powers the /checkout/:slug hosted checkout landing
  // page (checkout_url format per backend-t2a.md: .../checkout/{slug}).
  // GET path matches backend-t2a.md's documented route exactly: no
  // "/public" suffix — 404s for missing slug AND paused (active=False)
  // products, so a 404 here doesn't necessarily mean the slug is wrong.
  COMMERCE_PRODUCT_PUBLIC: (slug) => `/commerce/products/${slug}`,
  // Mints a fresh single-use T2A pay-request for this product's price, on
  // the product owner's behalf — the real, documented contract for this is
  // docs/cummerce/frontend-to-backend.md §3 (source of truth over any
  // older/conflicting inline comments). ProductCheckoutPage.js already
  // calls this and immediately pays against the returned token via the
  // existing public /gu-balance/pay-request/:token — see §3.1 for the
  // post-payment landing page that flow redirects to.
  COMMERCE_PRODUCT_CHECKOUT: (slug) =>
    `/commerce/products/${slug}/checkout`,
  // NOT part of the documented backend contract yet — see the
  // EXPECTED API SHAPES note in ProductManagement.js. Real payment
  // collection is Stripe/PayPal checkout + POST /commerce/orders/complete,
  // not this. Kept only until ProductCheckoutPage.js is reworked to match.
  COMMERCE_PRODUCT_CHECKOUT: (slug) =>
    `/commerce/products/${slug}/checkout`,

  // ── Third-party integration: hosted embedded-checkout page (public, no auth) ──
  // Powers /commerce/pay/:sessionId/:token. Authorization is the token itself
  // (HMAC-derived from the integration's API key at session-creation time),
  // not a JWT — see blitz-backend/docs/commerce/README.md §2a. Distinct from
  // COMMERCE_PRODUCT_CHECKOUT above, which belongs to the separate
  // merchant-defined-product-link Commerce system, not the API-key-driven
  // third-party integration this powers.
  COMMERCE_CHECKOUT_SESSION: (sessionId, token) =>
    `/commerce/checkout/${sessionId}/${token}`,
  COMMERCE_CHECKOUT_EMBED: (sessionId, token) =>
    `/commerce/checkout/${sessionId}/${token}/embed`,

  // ── Developer portal: integrations, API keys, webhooks ─────────────────────
  COMMERCE_INTEGRATIONS: "/commerce/integrations",
  COMMERCE_KEYS: "/commerce/keys",
  COMMERCE_KEY_REVEAL: "/commerce/keys/reveal",
  COMMERCE_KEY_ROTATE: "/commerce/keys/rotate",
  COMMERCE_KEY: (id) => `/commerce/keys/${id}`,
  COMMERCE_WEBHOOK: "/commerce/webhook",
  COMMERCE_WEBHOOK_ENABLE: "/commerce/webhook/enable",
  COMMERCE_WEBHOOK_DISABLE: "/commerce/webhook/disable",
  COMMERCE_WEBHOOK_ROTATE_SECRET: "/commerce/webhook/rotate-secret",
  COMMERCE_WEBHOOK_REVEAL_SECRET: "/commerce/webhook/reveal-secret",
  // Admin-only onboarding by email
  COMMERCE_ADMIN_INIT: "/commerce/initialize",
};
